(function() {

// ── Pre-paint section gate ─────────────────────────────────────────────────
// Read the URL hash synchronously and inject a CSS rule that hides every
// section except the target one — BEFORE the browser paints anything. This
// eliminates the "default page flashes for a moment" effect on hash deep
// links. Removed inside handleDeepLink() once the proper logic kicks in.
(function () {
    try {
        var raw = (location.hash || '').replace(/^#/, '');
        if (raw.indexOf('.') !== -1) raw = raw.split('.')[0];   // orders.faq-1 -> orders
        if (raw.indexOf('#') > 0)    raw = raw.substring(0, raw.indexOf('#'));
        var target = /^[a-zA-Z][\w-]*$/.test(raw) ? raw : 'orders';
        var style = document.createElement('style');
        style.id = 'cs-initial-section-gate';
        style.textContent =
            '.cs-section{display:none!important}' +
            '#' + target + '.cs-section{display:block!important}';
        (document.head || document.documentElement).appendChild(style);
    } catch (e) { /* never block the rest of the script */ }
})();

// Multi-language translation dictionaries
const translations = {
    'en-GB': {
        orderNumber: 'Order',
        placedOn: 'Placed on',
        paymentStatus: 'Payment Status',
        carrier: 'Carrier',
        shippingTo: 'Shipping To',
        contactEmail: 'Contact Email',
        orderItems: 'Order Items',
        total: 'Total',
        trackPackage: 'Track Package',
        shipped: 'Shipped',
        processing: 'Processing',
        pending: 'Pending Payment',
        paid: 'Paid',
        unpaid: 'Unpaid',
        refunded: 'Refunded',
        orderNotFound: 'Bestelling niet gevonden. Controleer je bestelnummer en e-mailadres.',
        connectionError: 'Kan geen verbinding maken met de server. Probeer het later opnieuw.',
        searching: 'Searching...',
        findMyOrder: 'Find My Order',
        qty: 'Qty',
        trackingAvailableSoon: 'Tracking will be available soon',
        untrackedDelivery: 'Your order has been dispatched and is on its way to you.',
        downloadInvoice: 'Download Invoice',
        invoice: 'Invoice',
        date: 'Date',
        orderDetails: 'Order Details',
        shippingDetails: 'Shipping Details',
        item: 'Item',
        quantity: 'Quantity',
        price: 'Price',
        status: 'Status',
        thankYou: 'Thank you for choosing Smartwatchbanden.nl. Your support means a lot to us.',
        popupBlocked: 'Please allow popups to download the invoice',
        estimatedDelivery: 'Estimated Delivery',
        orderPlaced: 'Order placed:',
        orderFulfilled: 'Order fulfilled:',
        estimatedArrival: 'Estimated arrival between:',
        expectedDeliveryWas: 'Expected delivery was:',
        deliverySignificantlyDelayed: 'Delivery Significantly Delayed',
        deliveryDelayed: 'Delivery Delayed',
        deliveryDelayedMessage: 'Your order may be delayed. The expected delivery window has passed, but the package may still be on its way.',
        deliverySignificantlyDelayedMessage: 'Your order is significantly overdue. The expected delivery window has passed, and we recommend reaching out to us immediately for assistance.',
        contactUsNow: 'contact us now',
        contactUsMessage: 'so we can investigate and help resolve this issue.',
        yourOrderShouldArrive: 'Your order should arrive within 2-4 working days from when it was shipped.'
    },
    'nl-NL': {
        orderNumber: 'Bestelling',
        placedOn: 'Geplaatst op',
        paymentStatus: 'Betaalstatus',
        carrier: 'Vervoerder',
        shippingTo: 'Verzenden naar',
        contactEmail: 'Contact E-mail',
        orderItems: 'Artikelen',
        total: 'Totaal',
        trackPackage: 'Pakket volgen',
        shipped: 'Verzonden',
        processing: 'In behandeling',
        pending: 'Betaling in behandeling',
        paid: 'Betaald',
        unpaid: 'Niet betaald',
        refunded: 'Terugbetaald',
        orderNotFound: 'Bestelling niet gevonden. Controleer uw bestelnummer en e-mailadres.',
        connectionError: 'Kan geen verbinding maken met de server. Probeer het later opnieuw.',
        searching: 'Zoeken...',
        findMyOrder: 'Mijn bestelling zoeken',
        qty: 'Aantal',
        trackingAvailableSoon: 'Tracking binnenkort beschikbaar',
        untrackedDelivery: 'Uw bestelling is verzonden en onderweg naar u.',
        downloadInvoice: 'Factuur downloaden',
        invoice: 'Factuur',
        date: 'Datum',
        orderDetails: 'Bestelgegevens',
        shippingDetails: 'Verzendgegevens',
        item: 'Artikel',
        quantity: 'Aantal',
        price: 'Prijs',
        status: 'Status',
        thankYou: 'Bedankt voor het kiezen van Smartwatchbanden.nl. Je steun betekent veel voor ons!',
        popupBlocked: 'Sta pop-ups toe om de factuur te downloaden',
        subtotal: 'Subtotaal',
        shipping: 'Verzendkosten',
        tax: 'BTW',
        discount: 'Korting',
        grandTotal: 'Totaalbedrag',
        estimatedDelivery: 'Verwachte Levertijd',
        orderPlaced: 'Bestelling geplaatst:',
        orderFulfilled: 'Bestelling verzonden:',
        estimatedArrival: 'Verwachte levering tussen:',
        expectedDeliveryWas: 'Verwachte levering was:',
        deliverySignificantlyDelayed: 'Levering Aanzienlijk Vertraagd',
        deliveryDelayed: 'Levering Mogelijk Vertraagd',
        deliveryDelayedMessage: 'Uw bestelling is mogelijk vertraagd. Het verwachte leveringsvenster is voorbij, maar het pakket kan nog steeds onderweg zijn.',
        deliverySignificantlyDelayedMessage: 'Uw bestelling is aanzienlijk te laat. Het verwachte leveringsvenster is verstreken en we raden u aan om onmiddellijk contact met ons op te nemen voor hulp.',
        contactUsNow: 'neem nu contact met ons op',
        contactUsMessage: 'zodat we dit probleem kunnen onderzoeken en helpen oplossen.',
        yourOrderShouldArrive: 'Uw bestelling zou binnen 2-4 werkdagen moeten aankomen vanaf het moment dat deze is verzonden.',
        yourOrderShouldArriveNL: 'Heb je jouw bestelling op een werkdag vóór 22:00 uur geplaatst? Dan wordt je bestelling dezelfde dag nog gratis verzonden met Track & Trace.<br><br>Standaardverzending: levering binnen 1–2 werkdagen.<br>PostNL Premium (€0,99): levering binnen 1 werkdag.',
        yourOrderShouldArriveBE: 'Bestellingen naar België doen er doorgaans 2–3 werkdagen over. Niet alle zendingen hebben Track & Trace, maar indien beschikbaar kun je jouw zending hierboven volgen.',
        nlDeliveryNote: 'Let op: Zondag en maandag bezorgt PostNL geen post of brievenbuspakketten.',
        beDeliveryNote: 'Bezorging via BPost.',
        nlExpectedDelivery: 'Verwachte levering:',
        beExpectedDelivery: 'Verwachte levering tussen:',
        company: 'Bedrijf'
    },
    'de-DE': {
        orderNumber: 'Bestellung',
        placedOn: 'Aufgegeben am',
        paymentStatus: 'Zahlungsstatus',
        carrier: 'Versanddienstleister',
        shippingTo: 'Versand nach',
        contactEmail: 'Kontakt E-Mail',
        orderItems: 'Bestellte Artikel',
        total: 'Gesamt',
        trackPackage: 'Paket verfolgen',
        shipped: 'Versandt',
        processing: 'In Bearbeitung',
        pending: 'Zahlung ausstehend',
        paid: 'Bezahlt',
        unpaid: 'Unbezahlt',
        refunded: 'Erstattet',
        orderNotFound: 'Bestellung nicht gefunden. Bitte überprüfen Sie Ihre Bestellnummer und E-Mail-Adresse.',
        connectionError: 'Verbindung zum Server nicht möglich. Bitte versuchen Sie es später erneut.',
        searching: 'Suchen...',
        findMyOrder: 'Meine Bestellung finden',
        qty: 'Menge',
        trackingAvailableSoon: 'Sendungsverfolgung bald verfügbar',
        untrackedDelivery: 'Ihre Bestellung wurde versandt und ist unterwegs zu Ihnen.',
        downloadInvoice: 'Rechnung herunterladen',
        invoice: 'Rechnung',
        date: 'Datum',
        orderDetails: 'Bestelldetails',
        shippingDetails: 'Versanddetails',
        item: 'Artikel',
        quantity: 'Menge',
        price: 'Preis',
        status: 'Status',
        thankYou: 'Vielen Dank für Ihren Einkauf!',
        popupBlocked: 'Bitte erlauben Sie Pop-ups, um die Rechnung herunterzuladen',
        estimatedDelivery: 'Voraussichtliche Lieferung',
        orderPlaced: 'Bestellung aufgegeben:',
        orderFulfilled: 'Bestellung versandt:',
        estimatedArrival: 'Voraussichtliche Ankunft zwischen:',
        expectedDeliveryWas: 'Erwartete Lieferung war:',
        deliverySignificantlyDelayed: 'Lieferung Erheblich Verzögert',
        deliveryDelayed: 'Lieferung Möglicherweise Verzögert',
        deliveryDelayedMessage: 'Ihre Bestellung könnte verzögert sein. Das erwartete Lieferfenster ist verstrichen, aber das Paket könnte noch unterwegs sein.',
        deliverySignificantlyDelayedMessage: 'Ihre Bestellung ist erheblich überfällig. Das erwartete Lieferfenster ist verstrichen und wir empfehlen Ihnen, sich sofort mit uns in Verbindung zu setzen.',
        contactUsNow: 'kontaktieren Sie uns jetzt',
        contactUsMessage: 'damit wir das Problem untersuchen und beheben können.',
        yourOrderShouldArrive: 'Ihre Bestellung sollte innerhalb von 2-4 Werktagen nach dem Versand ankommen.'
    },
    'es-ES': {
        orderNumber: 'Pedido',
        placedOn: 'Realizado el',
        paymentStatus: 'Estado del pago',
        carrier: 'Transportista',
        shippingTo: 'Envío a',
        contactEmail: 'Correo de contacto',
        orderItems: 'Artículos del pedido',
        total: 'Total',
        trackPackage: 'Rastrear paquete',
        shipped: 'Enviado',
        processing: 'Procesando',
        pending: 'Pago pendiente',
        paid: 'Pagado',
        unpaid: 'No pagado',
        refunded: 'Reembolsado',
        orderNotFound: 'Pedido no encontrado. Por favor, verifique su número de pedido y correo electrónico.',
        connectionError: 'No se puede conectar al servidor. Por favor, inténtelo más tarde.',
        searching: 'Buscando...',
        findMyOrder: 'Buscar mi pedido',
        qty: 'Cant',
        trackingAvailableSoon: 'Seguimiento disponible pronto',
        untrackedDelivery: 'Su pedido ha sido enviado y está en camino.',
        downloadInvoice: 'Descargar factura',
        invoice: 'Factura',
        date: 'Fecha',
        orderDetails: 'Detalles del pedido',
        shippingDetails: 'Detalles de envío',
        item: 'Artículo',
        quantity: 'Cantidad',
        price: 'Precio',
        status: 'Estado',
        thankYou: '¡Gracias por su compra!',
        popupBlocked: 'Por favor, permita ventanas emergentes para descargar la factura',
        estimatedDelivery: 'Entrega Estimada',
        orderPlaced: 'Pedido realizado:',
        orderFulfilled: 'Pedido enviado:',
        estimatedArrival: 'Llegada estimada entre:',
        expectedDeliveryWas: 'La entrega esperada era:',
        deliverySignificantlyDelayed: 'Entrega Significativamente Retrasada',
        deliveryDelayed: 'Entrega Posiblemente Retrasada',
        deliveryDelayedMessage: 'Su pedido podría estar retrasado. La ventana de entrega esperada ha pasado, pero el paquete aún podría estar en camino.',
        deliverySignificantlyDelayedMessage: 'Su pedido está significativamente atrasado. La ventana de entrega esperada ha pasado y le recomendamos que se comunique con nosotros de inmediato para obtener ayuda.',
        contactUsNow: 'contáctenos ahora',
        contactUsMessage: 'para que podamos investigar y ayudar a resolver este problema.',
        yourOrderShouldArrive: 'Su pedido debería llegar dentro de 2-4 días hábiles desde que fue enviado.'
    },
    'fr-FR': {
        orderNumber: 'Commande',
        placedOn: 'Passée le',
        paymentStatus: 'Statut du paiement',
        carrier: 'Transporteur',
        shippingTo: 'Expédition vers',
        contactEmail: 'E-mail de contact',
        orderItems: 'Articles commandés',
        total: 'Total',
        trackPackage: 'Suivre le colis',
        shipped: 'Expédié',
        processing: 'En cours',
        pending: 'Paiement en attente',
        paid: 'Payé',
        unpaid: 'Non payé',
        refunded: 'Remboursé',
        orderNotFound: 'Commande introuvable. Veuillez vérifier votre numéro de commande et votre adresse e-mail.',
        connectionError: 'Impossible de se connecter au serveur. Veuillez réessayer plus tard.',
        searching: 'Recherche...',
        findMyOrder: 'Trouver ma commande',
        qty: 'Qté',
        trackingAvailableSoon: 'Suivi disponible bientôt',
        untrackedDelivery: 'Votre commande a été expédiée et est en route.',
        downloadInvoice: 'Télécharger la facture',
        invoice: 'Factura',
        date: 'Date',
        orderDetails: 'Détails de la commande',
        shippingDetails: 'Détails d\'expédition',
        item: 'Article',
        quantity: 'Quantité',
        price: 'Prix',
        status: 'Statut',
        thankYou: 'Merci pour votre achat !',
        popupBlocked: 'Veuillez autoriser les pop-ups pour télécharger la facture',
        estimatedDelivery: 'Livraison Estimée',
        orderPlaced: 'Commande passée:',
        orderFulfilled: 'Commande expédiée:',
        estimatedArrival: 'Arrivée estimée entre:',
        expectedDeliveryWas: 'La livraison prévue était:',
        deliverySignificantlyDelayed: 'Livraison Significativement Retardée',
        deliveryDelayed: 'Livraison Possiblement Retardée',
        deliveryDelayedMessage: 'Votre commande pourrait être retardée. La fenêtre de livraison prévue est passée, mais le colis pourrait toujours être en route.',
        deliverySignificantlyDelayedMessage: 'Votre commande est significativement en retard. La fenêtre de livraison prévue est passée et nous vous recommandons de nous contacter immédiatement pour obtenir de l\'aide.',
        contactUsNow: 'contactez-nous maintenant',
        contactUsMessage: 'afin que nous puissions enquêter et aider à résoudre ce problème.',
        yourOrderShouldArrive: 'Votre commande devrait arriver dans les 2 à 4 jours ouvrables suivant l\'expédition.'
    }
};

// Carrier tracking URL templates
const carrierRegistry = {
    'PostNL': {
        countries: ['NL', 'Netherlands'],
        urlTemplate: (trackingCode, postcode) => {
            if (postcode) {
                return `https://jouw.postnl.nl/track-and-trace/${trackingCode}-NL-${postcode}`;
            }
            return `https://jouw.postnl.nl/track-and-trace/${trackingCode}`;
        },
        requiresPostcode: true
    },
    'Bpost': {
        countries: ['BE', 'Belgium'],
        urlTemplate: (trackingCode) => `https://track.bpost.cloud/btr/web/#/search?itemCode=${trackingCode}&lang=nl`,
        requiresPostcode: false
    },
    'Deutsche Post': {
        countries: ['DE', 'Germany'],
        urlTemplate: (trackingCode) => `https://www.deutschepost.de/de/s/sendungsverfolgung/verfolgen.html?piececode=${trackingCode}&lang=en&cid=brief`,
        requiresPostcode: false
    },
    'Sending ES': {
        countries: ['ES', 'Spain'],
        urlTemplate: (trackingCode) => `https://parcelsapp.com/es/tracking/${trackingCode}`,
        requiresPostcode: false
    },
    'Correos': {
        countries: ['ES', 'Spain'],
        urlTemplate: (trackingCode) => `https://parcelsapp.com/es/tracking/${trackingCode}`,
        requiresPostcode: false
    },
    'La Poste': {
        countries: ['FR', 'France'],
        urlTemplate: (trackingCode) => `https://www.laposte.fr/outils/suivre-vos-envois?code=${trackingCode}`,
        requiresPostcode: false
    },
    'Royal Mail': {
        countries: ['GB', 'UK', 'United Kingdom', 'IE', 'Ireland'],
        urlTemplate: (trackingCode) => `https://www.royalmail.com/track-your-item#/tracking-results/${trackingCode}`,
        requiresPostcode: false
    }
};

// Country to locale mapping
const countryToLocale = {
    'United Kingdom': 'en-GB',
    'GB': 'en-GB',
    'UK': 'en-GB',
    'Ireland': 'en-GB',
    'IE': 'en-GB',
    'Netherlands': 'nl-NL',
    'NL': 'nl-NL',
    'Belgium': 'nl-NL', // Default to Dutch for Belgium
    'BE': 'nl-NL',
    'Germany': 'de-DE',
    'DE': 'de-DE',
    'Spain': 'es-ES',
    'ES': 'es-ES',
    'France': 'fr-FR',
    'FR': 'fr-FR'
};

// Currency symbols
const currencySymbols = {
    'GBP': '£',
    'EUR': '€',
    'USD': '$'
};
// API endpoint configuration
const API_ENDPOINT = 'https://actium.automagically.nl/webhook/track-order';

const CS_SECTION_ORDER = ['orders', 'payment', 'returns', 'about', 'contact'];
let csCurrentSection = 'orders';

document.addEventListener('DOMContentLoaded', function() {
    // Safety check - only run on pages with customer service portal
    if (!document.querySelector('.cs-section')) {
        return;
    }

    const navItems = document.querySelectorAll('.cs-nav-item');
    const sections = document.querySelectorAll('.cs-section');
    const faqItems = document.querySelectorAll('.faq-item');
    const contactForm = document.getElementById('contactForm');
    let pendingTransition = null;

    function setActiveNav(sectionId) {
        document.querySelectorAll('.cs-nav-item').forEach(item => {
            item.classList.remove('active');
            if (item.dataset.section === sectionId) item.classList.add('active');
        });
        document.querySelectorAll('.cs-mobile-menu-item').forEach(item => {
            item.classList.remove('active');
            if (item.dataset.section === sectionId) item.classList.add('active');
        });
        document.querySelectorAll('.cs-tab-item').forEach(item => {
            item.classList.remove('active');
            if (item.dataset.section === sectionId) item.classList.add('active');
        });
    }

    function showSection(sectionId) {
        const targetSection = document.getElementById(sectionId);
        if (!targetSection) return;
        if (targetSection.classList.contains('page-active')) return;

        setActiveNav(sectionId);

        const currentIdx = CS_SECTION_ORDER.indexOf(csCurrentSection);
        const targetIdx  = CS_SECTION_ORDER.indexOf(sectionId);
        const goingForward = targetIdx > currentIdx;

        // Hide all other sections instantly
        document.querySelectorAll('.cs-section').forEach(section => {
            if (section.id !== sectionId) {
                section.classList.remove('page-active', 'slide-in-right', 'slide-in-left');
                section.classList.add('page-hidden');
            }
        });

        // Show target section
        targetSection.classList.remove('page-hidden', 'slide-in-right', 'slide-in-left');
        targetSection.classList.add('page-active');

        // Apply directional animation when both sections are known
        if (currentIdx !== -1 && targetIdx !== -1 && csCurrentSection !== sectionId) {
            void targetSection.offsetWidth; // force reflow
            const enterClass = goingForward ? 'slide-in-right' : 'slide-in-left';
            targetSection.classList.add(enterClass);
            targetSection.addEventListener('animationend', () => {
                targetSection.classList.remove('slide-in-right', 'slide-in-left');
            }, { once: true });
        }

        csCurrentSection = sectionId;
        window.scrollTo(0, 0);
    }

    window.showSection = showSection;

    // Use event delegation for nav items (more reliable in Shopify sections)
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.cs-section, .cs-header, .cs-nav, .cs-mobile-menu')) return;

        const navItem = e.target.closest('.cs-nav-item');
        if (navItem && navItem.dataset.section) {
            e.preventDefault();
            const sectionId = navItem.dataset.section;

            if (document.getElementById(sectionId)) {
                showSection(sectionId);

                const url = new URL(window.location);
                url.hash = sectionId;
                window.history.pushState({}, '', url);
            }
        }
    });

    function animateFaqOpen(answer) {
        if (!answer) return;
        answer.style.overflow = 'hidden';
        answer.style.height = '0px';
        answer.style.paddingBottom = '0';
        void answer.offsetHeight;
        const target = answer.scrollHeight;
        answer.style.transition = 'height 300ms cubic-bezier(0.4,0,0.2,1), padding-bottom 300ms cubic-bezier(0.4,0,0.2,1)';
        answer.style.height = target + 'px';
        answer.style.paddingBottom = '1.5rem';
        answer.addEventListener('transitionend', function h() {
            answer.style.height = 'auto';
            answer.style.overflow = '';
            answer.style.transition = '';
            answer.removeEventListener('transitionend', h);
        });
        // Orange inset flash on left edge
        const item = answer.closest('.faq-item');
        if (item) {
            item.style.boxShadow = 'inset 3px 0 0 var(--primary-orange), var(--shadow-sm)';
            setTimeout(() => { item.style.boxShadow = ''; }, 600);
        }
    }
    window.animateFaqOpen = animateFaqOpen;

    function animateFaqClose(answer) {
        if (!answer) return;
        const current = answer.getBoundingClientRect().height;
        if (current === 0) return;
        answer.style.overflow = 'hidden';
        answer.style.height = current + 'px';
        void answer.offsetHeight;
        answer.style.transition = 'height 300ms cubic-bezier(0.4,0,0.2,1), padding-bottom 300ms cubic-bezier(0.4,0,0.2,1)';
        answer.style.height = '0px';
        answer.style.paddingBottom = '0';
        answer.addEventListener('transitionend', function h() {
            answer.style.height = '';
            answer.style.overflow = '';
            answer.style.transition = '';
            answer.style.paddingBottom = '';
            answer.removeEventListener('transitionend', h);
        });
    }

    faqItems.forEach(item => {
        const question = item.querySelector('.faq-question');
        if (!question) return;
        question.addEventListener('click', function(e) {
            e.preventDefault();
            const isActive = item.classList.contains('active');
            // Close all other open FAQs
            faqItems.forEach(faq => {
                if (faq !== item && faq.classList.contains('active')) {
                    faq.classList.remove('active');
                    animateFaqClose(faq.querySelector('.faq-answer'));
                }
            });
            if (!isActive) {
                item.classList.add('active');
                animateFaqOpen(item.querySelector('.faq-answer'));
            } else {
                item.classList.remove('active');
                animateFaqClose(item.querySelector('.faq-answer'));
            }
        });
    });

    // ===== BOTTOM TAB BAR =====
    const tabBar = document.getElementById('csTabBar');
    if (tabBar) {
        tabBar.addEventListener('click', function(e) {
            const tabItem = e.target.closest('.cs-tab-item');
            if (!tabItem || !tabItem.dataset.section) return;
            const sectionId = tabItem.dataset.section;
            showSection(sectionId);
            const url = new URL(window.location);
            url.hash = sectionId;
            window.history.pushState({}, '', url);
            // Bounce animation
            tabItem.classList.remove('tab-bounce');
            void tabItem.offsetWidth;
            tabItem.classList.add('tab-bounce');
            tabItem.addEventListener('animationend', () => tabItem.classList.remove('tab-bounce'), { once: true });
        });
    }

    // Return cost box tap ripple (mobile)
    document.querySelectorAll('.return-cost-box').forEach(function(box) {
        box.addEventListener('touchstart', function() {
            box.classList.remove('cs-rippling');
            void box.offsetWidth;
            box.classList.add('cs-rippling');
            box.addEventListener('animationend', function() {
                box.classList.remove('cs-rippling');
            }, { once: true });
        }, { passive: true });
    });

    // Handle custom subject field visibility
    const subjectDropdown = document.getElementById('subject');
    const customSubjectGroup = document.getElementById('customSubjectGroup');
    const customSubjectInput = document.getElementById('customSubject');

    function updateCustomSubjectVisibility() {
        if (subjectDropdown && customSubjectGroup && customSubjectInput) {
            if (subjectDropdown.value === 'Anders') {
                customSubjectGroup.style.display = 'block';
                customSubjectInput.setAttribute('required', 'required');
            } else {
                customSubjectGroup.style.display = 'none';
                customSubjectInput.removeAttribute('required');
                customSubjectInput.value = '';
            }
        }
    }

    if (subjectDropdown && customSubjectGroup && customSubjectInput) {
        // Initialize on page load
        updateCustomSubjectVisibility();

        // Handle dropdown changes
        subjectDropdown.addEventListener('change', updateCustomSubjectVisibility);
    }

    // Handle File Upload UI
    const fileInput = document.getElementById('attachments');
    const fileList = document.getElementById('file-list');
    
    if (fileInput && fileList) {
        fileInput.addEventListener('change', function() {
            const files = Array.from(this.files).slice(0, 3);
            if (files.length === 0) { fileList.innerHTML = ''; fileList.style.display = 'none'; return; }
            const countLabel = files.length === 1 ? '1 bestand geselecteerd' : `${files.length} bestanden geselecteerd`;
            let html = `<div style="font-weight:700;margin-bottom:0.375rem;color:#1F2937;">${countLabel}</div>`;
            files.forEach(function(f, idx) {
                const mb = (f.size / 1048576).toFixed(1);
                html += `<div class="cs-attachment-row" style="display:flex;align-items:center;gap:0.5rem;padding:0.2rem 0;width:100%;min-width:0;box-sizing:border-box;">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;flex-shrink:0;color:var(--primary-orange);"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                    <span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${f.name}</span>
                    <span style="color:#6B7280;font-size:0.75rem;flex-shrink:0;white-space:nowrap;">${mb} MB</span>
                    <button type="button" class="cs-attachment-remove" data-idx="${idx}" aria-label="Verwijderen" title="Verwijderen">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:14px;height:14px;"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                    </button>
                </div>`;
            });
            if (this.files.length > 3) {
                html += '<div style="color:#b45309;margin-top:0.375rem;font-style:italic;">Alleen de eerste 3 worden verzonden.</div>';
            }
            fileList.innerHTML = html;
            fileList.style.display = 'block';
        });

        // Click delegation: remove a single attachment by index
        fileList.addEventListener('click', function(e) {
            const btn = e.target.closest('.cs-attachment-remove');
            if (!btn) return;
            e.preventDefault();
            const idx = parseInt(btn.getAttribute('data-idx'), 10);
            if (isNaN(idx) || !fileInput.files) return;
            const dt = new DataTransfer();
            Array.from(fileInput.files).forEach(function(f, i) {
                if (i !== idx) dt.items.add(f);
            });
            fileInput.files = dt.files;
            fileInput.dispatchEvent(new Event('change'));
        });

        // Drag-and-drop support
        const dropZone = document.querySelector('.cs-file-drop');
        if (dropZone) {
            ['dragenter', 'dragover'].forEach(function(ev) {
                dropZone.addEventListener(ev, function(e) {
                    e.preventDefault(); e.stopPropagation();
                    dropZone.classList.add('is-drag');
                });
            });
            ['dragleave', 'dragend'].forEach(function(ev) {
                dropZone.addEventListener(ev, function(e) {
                    e.preventDefault(); e.stopPropagation();
                    dropZone.classList.remove('is-drag');
                });
            });
            dropZone.addEventListener('drop', function(e) {
                e.preventDefault(); e.stopPropagation();
                dropZone.classList.remove('is-drag');
                const dt = e.dataTransfer;
                if (!dt || !dt.files || !dt.files.length) return;
                try {
                    const out = new DataTransfer();
                    let added = 0;
                    for (let i = 0; i < dt.files.length && added < 3; i++) {
                        if (/^image\//i.test(dt.files[i].type)) { out.items.add(dt.files[i]); added++; }
                    }
                    if (out.files.length) {
                        fileInput.files = out.files;
                        fileInput.dispatchEvent(new Event('change'));
                    }
                } catch (err) {
                    fileInput.files = dt.files;
                    fileInput.dispatchEvent(new Event('change'));
                }
            });
        }
    }

    if (contactForm) {
        contactForm.addEventListener('submit', async function(e) {
            e.preventDefault();

            // Check if form is valid (HTML5 validation)
            if (!contactForm.checkValidity()) {
                contactForm.reportValidity();
                return;
            }

            const subjectDropdown = document.getElementById('subject').value;
            const customSubject = document.getElementById('customSubject').value;
            
            // Use custom subject if "Anders" was selected, otherwise use dropdown value
            const subject = subjectDropdown === 'Anders' && customSubject ? customSubject : subjectDropdown;

            const submitBtn = contactForm.querySelector('.cs-submit-btn');
            const statusDiv = document.getElementById('contactStatus');
            const originalText = submitBtn.textContent;

            // Create FormData object early so we can extract values easily
            const formData = new FormData(contactForm);

            // =========================================================================
            // FEATURE FLAG: SET TO 'true' LATER TO RE-ACTIVATE THE N8N WEBHOOK
            // =========================================================================
            const USE_WEBHOOK = true;

            if (!USE_WEBHOOK) {
                // FALLBACK METHOD: Open native email client with pre-filled text
                const name = formData.get('name') || '';
                const email = formData.get('email') || '';
                const order = formData.get('order') || '';
                const message = formData.get('message') || '';

                // Smart routing: Determine target email based on HTML lang attribute
                const currentLang = document.documentElement.lang || 'nl';
                let targetEmail = 'service@smartwatchbanden.nl'; // Default NL
                if (currentLang.includes('de')) targetEmail = 'service@smartwatcharmbaender.de';
                else if (currentLang.includes('fr')) targetEmail = 'service@braceletsmartwatch.fr';
                else if (currentLang.includes('es')) targetEmail = 'service@correasmartwatch.es';
                else if (currentLang.includes('en')) targetEmail = 'service@smartwatch-straps.co.uk';

                const mailtoSubject = `[${subject}] Order: ${order || 'Onbekend'}`;
                const mailtoBody = `Naam: ${name}\nE-mailadres: ${email}\nOrdernummer: ${order}\nWinkel: Klantenservice Portaal\n\nBericht:\n${message}\n\n------------------------------\nLet op: Als u foto's of bestanden wilt meesturen, voeg deze dan nu als bijlage toe aan deze e-mail voordat u op verzenden drukt.`;

                // Trigger the mailto link
                window.location.href = `mailto:${targetEmail}?subject=${encodeURIComponent(mailtoSubject)}&body=${encodeURIComponent(mailtoBody)}`;

                // Show a helpful UI message that the email app was opened
                statusDiv.innerHTML = `
                    <div class="cs-status-anim" style="display: flex; gap: 0.875rem; align-items: flex-start; padding: 1.25rem; background: linear-gradient(135deg, #F0F9FF 0%, #E0F2FE 100%); border: 1px solid #0EA5E9; border-radius: 12px;">
                        <div style="background: white; border-radius: 50%; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; box-shadow: 0 2px 4px rgba(14, 165, 233, 0.1);">
                            <svg viewBox="0 0 24 24" fill="none" stroke="#0284C7" stroke-width="2.5" style="width: 16px; height: 16px;">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                <polyline points="22,6 12,13 2,6"></polyline>
                            </svg>
                        </div>
                        <div>
                            <h4 style="margin: 0 0 0.25rem 0; color: #0369A1; font-size: 0.9375rem; font-weight: 700;">E-mailprogramma geopend</h4>
                            <p style="margin: 0; color: #075985; font-size: 0.875rem; line-height: 1.5;">Je e-mailprogramma is zojuist geopend. <strong>Vergeet niet je foto's of bestanden handmatig toe te voegen</strong> voordat je de e-mail verstuurt!</p>
                        </div>
                    </div>
                `;
                statusDiv.style.display = 'block';

                // Reset the form UI
                contactForm.reset();
                updateCustomSubjectVisibility();
                const fileList = document.getElementById('file-list');
                if (fileList) fileList.innerHTML = '';
                
                return; // Stop execution here so it bypasses the n8n logic below
            }

            // =========================================================================
            // ORIGINAL N8N WEBHOOK LOGIC (Currently dormant)
            // =========================================================================
            
            submitBtn.textContent = 'Bezig met verzenden...';
            submitBtn.disabled = true;
            statusDiv.style.display = 'none';

            // Overwrite the subject with the computed value
            formData.set('subject', subject);
            
            // Add identifying info so n8n knows where it came from
            formData.append('source', 'Klantenservice Portaal NL');

            // Force attach files (fixes missing name="" attribute bugs)
            const fileInputNode = document.getElementById('attachments');
            if (fileInputNode && fileInputNode.files.length > 0) {
                // Clear any auto-appended files to prevent duplicates
                formData.delete('attachments');
                formData.delete('attachments[]');
                formData.delete('attachment');

                const MAX_FILES = 3;
                const MAX_SIZE_MB = 5;
                const MAX_TOTAL_MB = 15;
                const sendFiles = Array.from(fileInputNode.files).slice(0, MAX_FILES);
                let total = 0;
                let tooBig = null;
                for (let i = 0; i < sendFiles.length; i++) {
                    total += sendFiles[i].size;
                    if (sendFiles[i].size > MAX_SIZE_MB * 1024 * 1024) { tooBig = sendFiles[i]; break; }
                }
                if (tooBig) {
                    submitBtn.textContent = originalText;
                    submitBtn.disabled = false;
                    statusDiv.innerHTML = `<div class="cs-status-anim" style="padding:1rem 1.25rem;background:linear-gradient(135deg,#FEE2E2 0%,#FECACA 100%);border:2px solid rgba(220,38,38,0.3);color:#991B1B;border-radius:12px;font-weight:600;font-size:0.9rem;">Afbeelding te groot (max. 5 MB): ${tooBig.name}</div>`;
                    statusDiv.style.display = 'block';
                    return;
                }
                if (total > MAX_TOTAL_MB * 1024 * 1024) {
                    const totalMb = (total / 1048576).toFixed(1);
                    submitBtn.textContent = originalText;
                    submitBtn.disabled = false;
                    statusDiv.innerHTML = `<div class="cs-status-anim" style="padding:1rem 1.25rem;background:linear-gradient(135deg,#FEE2E2 0%,#FECACA 100%);border:2px solid rgba(220,38,38,0.3);color:#991B1B;border-radius:12px;font-weight:600;font-size:0.9rem;">Afbeeldingen samen te groot (${totalMb} MB, max. ${MAX_TOTAL_MB} MB totaal). Upload kleinere of minder afbeeldingen.</div>`;
                    statusDiv.style.display = 'block';
                    return;
                }

                sendFiles.forEach((file, index) => {
                    formData.append(`attachment_${index}`, file);
                });
            }

            try {
                // n8n Webhook URL voor het contactformulier
                const webhookUrl = 'https://actium.automagically.nl/webhook/cs-contact-form';
                
                const response = await fetch(webhookUrl, {
                    method: 'POST',
                    body: formData
                });

                if (response.ok) {
                    statusDiv.innerHTML = `
                        <div class="cs-status-anim" style="display: flex; gap: 0.875rem; align-items: flex-start; padding: 1.25rem; background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%); border: 1px solid #10B981; border-radius: 12px;">
                            <div style="background: white; border-radius: 50%; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; box-shadow: 0 2px 4px rgba(5, 150, 105, 0.1);">
                                <svg viewBox="0 0 24 24" fill="none" stroke="#059669" stroke-width="2.5" style="width: 16px; height: 16px;">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </div>
                            <div>
                                <h4 style="margin: 0 0 0.25rem 0; color: #065F46; font-size: 0.9375rem; font-weight: 700;">Bericht verzonden!</h4>
                                <p style="margin: 0; color: #047857; font-size: 0.875rem; line-height: 1.5;">We hebben je bericht in goede orde ontvangen. We nemen zo snel mogelijk contact met je op.</p>
                            </div>
                        </div>
                    `;
                    statusDiv.style.display = 'block';
                    
                    contactForm.reset();
                    updateCustomSubjectVisibility();
                    
                    // Reset ook de bestandslijst
                    const fileList = document.getElementById('file-list');
                    if (fileList) fileList.innerHTML = '';
                    
                } else {
                    throw new Error('Server response was not ok.');
                }
            } catch (error) {
                console.error('Submission error:', error);
                statusDiv.innerHTML = `
                    <div class="cs-status-anim" style="display: flex; gap: 0.875rem; align-items: flex-start; padding: 1.25rem; background: linear-gradient(135deg, #FEF2F2 0%, #FEE2E2 100%); border: 1px solid #EF4444; border-radius: 12px;">
                        <div style="background: white; border-radius: 50%; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; box-shadow: 0 2px 4px rgba(185, 28, 28, 0.1);">
                            <svg viewBox="0 0 24 24" fill="none" stroke="#B91C1C" stroke-width="2.5" style="width: 16px; height: 16px;">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </div>
                        <div>
                            <h4 style="margin: 0 0 0.25rem 0; color: #991B1B; font-size: 0.9375rem; font-weight: 700;">Verzenden mislukt</h4>
                            <p style="margin: 0; color: #7F1D1D; font-size: 0.875rem; line-height: 1.5;">Er is helaas iets misgegaan bij het verzenden. Probeer het later nog eens of neem telefonisch contact op.</p>
                        </div>
                    </div>
                `;
                statusDiv.style.display = 'block';
            } finally {
                submitBtn.textContent = originalText;
                submitBtn.disabled = false;
            }
        });
    }

    // ===== ROBUST DIXA TRIGGER =====
    const dixaButton = document.getElementById('csDixaButton');
    if (dixaButton) {
        dixaButton.addEventListener('click', function(e) {
            e.preventDefault();

            // 1. Show visual hint immediately
            const hint = document.getElementById('csDixaChatHint');
            if (hint) hint.style.display = 'block';

            // 2. Hide CS mobile menu immediately when opening Dixa
            const mobileMenuForDixa = document.getElementById('csMobileMenu');
            if (mobileMenuForDixa) {
                mobileMenuForDixa.style.display = 'none';
                mobileMenuForDixa.classList.remove('expanded');
                document.body.classList.remove('cs-menu-open');
            }

            // 3. Trigger Dixa ONCE (prevents the 'ghost reopening' bug)
            if (typeof window._dixa_ !== 'undefined' && typeof window._dixa_.invoke === 'function') {
                window._dixa_.invoke('setWidgetOpen', true);
            } else if (typeof window.dixa !== 'undefined' && typeof window.dixa._invoke === 'function') {
                window.dixa._invoke('setWidgetOpen', true);
            }
        });
    }

    // Mobile menu functionality
    const mobileMenu = document.getElementById('csMobileMenu');
    const tabBarNav = document.getElementById('csTabBar');
    const mobileMenuToggle = document.getElementById('csMobileMenuToggle');

    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', function() {
            const isExpanding = !mobileMenu.classList.contains('expanded');
            mobileMenu.classList.toggle('expanded');

            if (isExpanding) {
                // Opening: Hide Dixa IMMEDIATELY so it doesn't overlap
                document.body.classList.add('cs-menu-open');
            } else {
                // Closing: Wait for animation (350ms) before bringing Dixa back
                // Adjust 350 to match your CSS transition time
                setTimeout(() => {
                    // Check if menu is still closed (in case user clicked fast)
                    if (!mobileMenu.classList.contains('expanded')) {
                        document.body.classList.remove('cs-menu-open');
                    }
                }, 350); 
            }
        });
    }

    // Use event delegation for mobile menu items
    if (mobileMenu) {
        mobileMenu.addEventListener('click', function(e) {
            const menuItem = e.target.closest('.cs-mobile-menu-item');
            if (menuItem && menuItem.dataset.section) {
                e.preventDefault();
                const sectionId = menuItem.dataset.section;
                showSection(sectionId);

                // Close mobile menu
                mobileMenu.classList.remove('expanded');
                
                // Wait for animation (350ms) before showing Dixa again
                setTimeout(() => {
                    document.body.classList.remove('cs-menu-open');
                }, 350);
            }
        });
    }

    // Z-index management: Hide CS mobile menu when Dixa chat opens or Shopify main menu opens
    if (mobileMenu || tabBarNav) {
        // Tracked state flags (event-driven, not polled)
        let isDixaOpen = false;
        let isShopifyMenuOpen = false;

        // Debounce utility
        let syncTimeout = null;
        const syncFloatingMenuLayer = () => {
            if (syncTimeout) clearTimeout(syncTimeout);
            syncTimeout = setTimeout(() => {
                if (isDixaOpen) {
                    // Hide CS mobile menu completely when Dixa chat is open
                    if (mobileMenu) {
                        mobileMenu.style.display = 'none';
                        mobileMenu.classList.add('hidden-for-dixa');
                        mobileMenu.classList.remove('lower-z-index');
                    }
                    if (tabBarNav) tabBarNav.style.display = 'none';
                } else if (isShopifyMenuOpen) {
                    // Lower z-index so Shopify menu appears on top (set to 10, well below typical menu z-indexes)
                    if (mobileMenu) {
                        mobileMenu.style.display = '';
                        mobileMenu.style.zIndex = '10';
                        mobileMenu.classList.add('lower-z-index');
                        mobileMenu.classList.remove('hidden-for-dixa');
                    }
                    if (tabBarNav) tabBarNav.style.zIndex = '10';
                } else {
                    // Restore normal state with max z-index
                    if (mobileMenu) {
                        mobileMenu.style.display = '';
                        mobileMenu.style.zIndex = '';
                        mobileMenu.classList.remove('hidden-for-dixa', 'lower-z-index');
                    }
                    if (tabBarNav) {
                        tabBarNav.style.display = '';
                        tabBarNav.style.zIndex = '';
                    }
                }
            }, 50);
        };

        // === DIXA DETECTION ===
        // Method 1: Use official Dixa API events (preferred method)
        const setupDixaEventListeners = () => {
            // Dixa uses _dixa_ global object with addListener method
            if (typeof _dixa_ !== 'undefined' && _dixa_.addListener) {
                _dixa_.addListener('on-widget-opened', () => {
                    isDixaOpen = true;
                    syncFloatingMenuLayer();
                    console.log('Dixa widget opened - hiding CS menu');
                });
                _dixa_.addListener('on-widget-closed', () => {
                    isDixaOpen = false;
                    syncFloatingMenuLayer();
                    console.log('Dixa widget closed - restoring CS menu');
                });
                return true;
            }
            // Also try the older dixa object
            if (typeof dixa !== 'undefined' && dixa.addListener) {
                dixa.addListener('on-widget-opened', () => {
                    isDixaOpen = true;
                    syncFloatingMenuLayer();
                });
                dixa.addListener('on-widget-closed', () => {
                    isDixaOpen = false;
                    syncFloatingMenuLayer();
                });
                return true;
            }
            return false;
        };

        // Try to setup Dixa listeners (retry if not loaded yet)
        if (!setupDixaEventListeners()) {
            setTimeout(() => setupDixaEventListeners(), 1000);
            setTimeout(() => setupDixaEventListeners(), 3000);
            setTimeout(() => setupDixaEventListeners(), 6000);
        }

        // Method 2: Observe Dixa container/overlay for visibility changes (fallback)
        const observeDixaContainer = () => {
            // Look for Dixa widget containers and overlays
            const dixaSelectors = '[id*="dixa"], [class*="dixa"], [class*="Dixa"], .dixaWidget__overlay';
            const dixaElements = document.querySelectorAll(dixaSelectors);

            dixaElements.forEach(dixaContainer => {
                const dixaObserver = new MutationObserver(() => {
                    // Check all Dixa elements for visibility
                    let anyDixaVisible = false;
                    document.querySelectorAll(dixaSelectors).forEach(el => {
                        const style = window.getComputedStyle(el);
                        const rect = el.getBoundingClientRect();
                        // Consider visible if displayed, not hidden, has opacity, and substantial size
                        if (style.display !== 'none' && 
                            style.visibility !== 'hidden' && 
                            parseFloat(style.opacity) > 0.3 &&
                            rect.width > 150 && rect.height > 150) {
                            anyDixaVisible = true;
                        }
                    });

                    if (anyDixaVisible !== isDixaOpen) {
                        isDixaOpen = anyDixaVisible;
                        syncFloatingMenuLayer();
                    }
                });
                dixaObserver.observe(dixaContainer, { 
                    attributes: true, 
                    attributeFilter: ['style', 'class', 'aria-hidden', 'data-state', 'hidden'],
                    childList: true
                });
            });
        };
        // Try to find Dixa container now and periodically (it may load async)
        observeDixaContainer();
        setTimeout(observeDixaContainer, 2000);
        setTimeout(observeDixaContainer, 5000);

        // === SHOPIFY MENU DETECTION ===
        // Method 1: Add click listeners to menu toggle buttons (comprehensive selectors)
        const setupShopifyMenuListeners = () => {
            const menuToggleSelectors = [
                '.header__icon--menu', '.menu-toggle', '[data-action="toggle-menu"]',
                '.mobile-nav-toggle', '.js-menu-toggle', 'header button[aria-controls*="menu"]',
                'header summary', '.header summary', '.header__menu-toggle',
                '[data-menu-toggle]', '.hamburger', '.burger-menu', '.nav-toggle',
                '.mobile-menu-toggle', 'button.menu', '[aria-label*="menu"]',
                '.header__icon--hamburger', '.site-header__menu-toggle'
            ];

            const menuToggles = document.querySelectorAll(menuToggleSelectors.join(', '));
            menuToggles.forEach(toggle => {
                toggle.addEventListener('click', () => {
                    // Check state after click animation
                    setTimeout(checkShopifyMenuState, 50);
                    setTimeout(checkShopifyMenuState, 150);
                    setTimeout(checkShopifyMenuState, 300);
                });
            });

            // Listen for drawer close buttons
            const closeButtonSelectors = [
                '.menu-drawer__close', '.drawer__close', '[data-action="close-menu"]',
                '.menu-close', '.js-menu-close', '.close-menu', '[aria-label*="close"]',
                '.menu-drawer__close-button', '.drawer-close'
            ];
            const closeButtons = document.querySelectorAll(closeButtonSelectors.join(', '));
            closeButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    setTimeout(() => {
                        isShopifyMenuOpen = false;
                        syncFloatingMenuLayer();
                    }, 100);
                });
            });

            // Listen for overlay clicks (closing menu by clicking outside)
            document.addEventListener('click', (e) => {
                if (!e.target.closest('.cs-section, .cs-header, .cs-nav, .cs-mobile-menu')) return;

                if (e.target.matches('.menu-drawer__overlay, .drawer-overlay, .nav-overlay, [class*="overlay"]')) {
                    setTimeout(() => {
                        isShopifyMenuOpen = false;
                        syncFloatingMenuLayer();
                    }, 100);
                }
            });
        };

        // Method 2: Check drawer element and body/html classes for open state
        const checkShopifyMenuState = () => {
            const wasOpen = isShopifyMenuOpen;

            // Check for panel-based drawer (Impact/Prestige themes) - .panel__scroller visible
            const panelScroller = document.querySelector('.panel__scroller');
            let panelOpen = false;
            if (panelScroller) {
                const panelParent = panelScroller.closest('[open], .is-open, [aria-hidden="false"]');
                if (panelParent) {
                    panelOpen = true;
                } else {
                    // Check if panel is visible by checking computed styles
                    const style = window.getComputedStyle(panelScroller);
                    const rect = panelScroller.getBoundingClientRect();
                    if (style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 50) {
                        panelOpen = true;
                    }
                }
            }

            // Check for navigation-drawer custom element (common in modern themes)
            const navDrawer = document.querySelector('navigation-drawer[open], [is="navigation-drawer"][open]');

            // Check for close-button being visible (indicates a drawer is open)
            const closeButton = document.querySelector('button[is="close-button"], .panel button[aria-label="Close"]');
            let closeButtonVisible = false;
            if (closeButton) {
                const style = window.getComputedStyle(closeButton);
                const rect = closeButton.getBoundingClientRect();
                if (style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0) {
                    closeButtonVisible = true;
                }
            }

            // Comprehensive check for open drawer elements
            const openDrawerSelectors = [
                'menu-drawer[open]', '[data-menu-drawer][open]', 'details[open].menu-drawer',
                '.menu-drawer.is-open', '.menu-drawer--open', '.menu-drawer.active',
                '.drawer.is-open', '.drawer.active', '.drawer--open', '.drawer[open]',
                '.mobile-nav.is-open', '.mobile-nav.active', '.mobile-nav--open',
                '.menu-drawer__inner.is-open', '[aria-hidden="false"].menu-drawer',
                '.site-nav.is-open', '.header-menu.is-open',
                '.panel.is-open', '.panel[open]', '[class*="drawer"][open]'
            ];
            const openDrawer = document.querySelector(openDrawerSelectors.join(', '));

            // Comprehensive body class check
            const bodyClasses = document.body.className.toLowerCase();
            const openClassPatterns = [
                'drawer-open', 'js-drawer-open', 'drawer-opening',
                'overflow-hidden', 'no-scroll', 'menu-open', 'nav-open',
                'mobile-nav-open', 'is-open', 'has-open-drawer', 'freeze'
            ];
            const hasOpenClass = openClassPatterns.some(pattern => bodyClasses.includes(pattern));

            // Also check html element classes
            const htmlClasses = document.documentElement.className.toLowerCase();
            const hasHtmlOpenClass = openClassPatterns.some(pattern => htmlClasses.includes(pattern));

            // Check for open details elements in header
            const openDetails = document.querySelector(
                'header details[open], .header details[open], .shopify-section-header details[open], .site-header details[open]'
            );

            // Check for visible overlay elements (indicates menu is open)
            const visibleOverlay = document.querySelector(
                '.menu-drawer__overlay:not([hidden]), .drawer-overlay[aria-hidden="false"], ' +
                '.nav-overlay.is-visible, [class*="overlay"].is-open, .page-overlay.is-visible'
            );

            isShopifyMenuOpen = !!(panelOpen || navDrawer || closeButtonVisible || openDrawer || hasOpenClass || hasHtmlOpenClass || openDetails || visibleOverlay);

            if (wasOpen !== isShopifyMenuOpen) {
                syncFloatingMenuLayer();
            }
        };

        // Method 3: Observe drawer elements for attribute changes
        const observeShopifyDrawer = () => {
            const drawerSelectors = [
                'menu-drawer', '[data-menu-drawer]', '.menu-drawer',
                'header details', '.header details', '.drawer',
                '.panel', '.panel__scroller', 'navigation-drawer',
                '[is="navigation-drawer"]', 'button[is="close-button"]'
            ];
            const drawers = document.querySelectorAll(drawerSelectors.join(', '));

            drawers.forEach(drawer => {
                const drawerObserver = new MutationObserver(() => {
                    checkShopifyMenuState();
                });
                drawerObserver.observe(drawer, { 
                    attributes: true, 
                    attributeFilter: ['open', 'aria-hidden', 'class', 'style', 'hidden']
                });

                // Also listen for transitionend events (menu animation complete)
                drawer.addEventListener('transitionend', checkShopifyMenuState);
            });
        };

        // Method 4: Observe body and html for class changes
        const bodyObserver = new MutationObserver(checkShopifyMenuState);
        bodyObserver.observe(document.body, { 
            attributes: true, 
            attributeFilter: ['class', 'style']
        });
        bodyObserver.observe(document.documentElement, { 
            attributes: true, 
            attributeFilter: ['class']
        });

        // Initialize all listeners
        setupShopifyMenuListeners();
        observeShopifyDrawer();

        // Fallback: minimal polling as safety net (every 500ms, much less aggressive)
        setInterval(() => {
            checkShopifyMenuState();
            // Also check Dixa container visibility as fallback
            const dixaContainer = document.querySelector('[id^="dixa"], [class*="dixa-messenger"]');
            if (dixaContainer) {
                const style = window.getComputedStyle(dixaContainer);
                const rect = dixaContainer.getBoundingClientRect();
                const nowOpen = style.display !== 'none' && 
                               style.visibility !== 'hidden' && 
                               parseFloat(style.opacity) > 0.3 &&
                               rect.width > 200 && rect.height > 200;
                if (nowOpen !== isDixaOpen) {
                    isDixaOpen = nowOpen;
                    syncFloatingMenuLayer();
                }
            }
        }, 500);

        // Initial state check
        checkShopifyMenuState();
        syncFloatingMenuLayer();
    }

    // ==========================================
    // UPDATED DEEP LINKING & NAVIGATION LOGIC
    // ==========================================

    // Handle all link clicks - fixes hash links from footer/external
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.cs-section, .cs-header, .cs-nav, .cs-mobile-menu')) return;

        const link = e.target.closest('a[href]');
        if (!link) return;

        const href = link.getAttribute('href');
        let hash = '';

        if (href.startsWith('#')) {
            hash = href.substring(1);
        } else if (href.includes('#')) {
            try {
                const linkUrl = new URL(href, window.location.origin);
                const currentUrl = new URL(window.location.href);
                if (linkUrl.pathname === currentUrl.pathname && linkUrl.hash) {
                    hash = linkUrl.hash.substring(1);
                }
            } catch (err) { return; }
        }

        if (hash) {
            if (hash.includes('.')) return;
            e.preventDefault();
            handleDeepLink(hash);
        }
    });

    // Main function to handle deep linking (FAQs, Sections, etc)
    function handleDeepLink(hashOverride) {
        // Remove the pre-paint section gate (no-op if missing)
        var __gate = document.getElementById('cs-initial-section-gate');
        if (__gate && __gate.parentNode) __gate.parentNode.removeChild(__gate);

        const hash = hashOverride || window.location.hash.substring(1);

        // Default to 'orders' if no hash exists
        if (!hash) {
            // Only force orders if no section is active (initial load)
            if (!document.querySelector('.cs-section.page-active')) {
                showSection('orders');
            }
            return;
        }

        // FAQ deep link with dot separator (e.g., orders.faq-orders-track)
        // Let the FAQ Navigation handler deal with these
        if (hash.includes('.')) {
            var dotIdx = hash.indexOf('.');
            var sectionId = hash.substring(0, dotIdx);
            if (document.getElementById(sectionId)) {
                showSection(sectionId);
            }
            return;
        }

        const targetElement = document.getElementById(hash);
        let sectionToShow = 'orders'; // Fallback
        let shouldScrollToElement = false;

        if (targetElement) {
            // Scenario 1: The hash is a Page Section (e.g., #faq)
            if (targetElement.classList.contains('cs-section')) {
                sectionToShow = hash;
                shouldScrollToElement = false; // showSection handles top scroll
            } 
            // Scenario 2: The hash is an Element INSIDE a section (e.g., #faq-orders-processed)
            else {
                const parentSection = targetElement.closest('.cs-section');
                if (parentSection) {
                    sectionToShow = parentSection.id;
                    shouldScrollToElement = true;
                }
            }
        } else {
            // Scenario 3: ID doesn't exist, just show default or requested section if valid
            if (document.getElementById(hash) && document.getElementById(hash).classList.contains('cs-section')) {
                sectionToShow = hash;
            }
        }

        // 1. Switch to the correct page
        showSection(sectionToShow);

        // Update URL without scrolling
        if (hash !== window.location.hash.substring(1)) {
            const url = new URL(window.location);
            url.hash = hash;
            window.history.pushState({}, '', url);
        }

        // 2. Handle specific element actions (Opening Accordions)
        if (targetElement && shouldScrollToElement) {
            // If it's an FAQ item, expand it
            if (targetElement.classList.contains('faq-item')) {
                // Optional: Close other active items first
                document.querySelectorAll('.faq-item').forEach(item => item.classList.remove('active'));

                // Open the specific item
                targetElement.classList.add('active');
            }

            // 3. Scroll to the element with a slight delay to allow UI to update
            setTimeout(() => {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 100);
        }
    }

    // Handle Browser Back/Forward buttons
    window.addEventListener('popstate', function() {
        handleDeepLink();
    });

    // Handle manual hash changes
    window.addEventListener('hashchange', function() {
        handleDeepLink();
    });

    // Initialize immediately — DOMContentLoaded guarantees DOM-ready
    var _initHash = window.location.hash.substring(1);
    if (_initHash) {
        handleDeepLink();
    } else {
        setActiveNav('orders');
        window.scrollTo(0, 0);
    }

    // Remove the pre-paint section gate (no-op if already removed)
    var __initGate = document.getElementById('cs-initial-section-gate');
    if (__initGate && __initGate.parentNode) __initGate.parentNode.removeChild(__initGate);

    // ── URL Prefill: Auto-fill & submit order lookup from query params ──
    // Link format: /pages/klantenservice?orderNumber=1234&orderEmail=test@test.nl#orders
    (function() {
        const urlParams = new URLSearchParams(window.location.search);
        const urlOrderNumber = urlParams.get('orderNumber');
        const urlOrderEmail  = urlParams.get('orderEmail');

        if (urlOrderNumber && urlOrderEmail) {
            const numInput   = document.getElementById('orderNumber');
            const emailInput = document.getElementById('orderEmail');

            if (numInput && emailInput) {
                numInput.value   = urlOrderNumber;
                emailInput.value = urlOrderEmail;

                // Make sure the Orders section is visible
                showSection('orders');

                // Auto-trigger the lookup once the section has rendered
                setTimeout(function() {
                    if (typeof window.lookupOrder === 'function') {
                        window.lookupOrder();
                    }
                }, 600);
            }
        }
    })();
});

// ===== SMART FAQ SEARCH ENGINE =====
(function() {
    var faqIndex = [];

    function buildIndex() {
        var labels = { orders: 'Bestellingen', payment: 'Betaling', returns: 'Retouren', about: 'Over Ons', contact: 'Contact' };
        document.querySelectorAll('.faq-item').forEach(function(item) {
            var qEl = item.querySelector('.faq-question span');
            var aEl = item.querySelector('.faq-answer');
            var section = item.closest('.cs-section');
            if (!qEl || !section) return;
            faqIndex.push({
                question: qEl.textContent.trim(),
                answer: aEl ? aEl.textContent.replace(/\s+/g, ' ').trim().substring(0, 300) : '',
                sectionId: section.id,
                sectionLabel: labels[section.id] || section.id,
                element: item
            });
        });
    }

    function score(entry, query) {
        var q = query.toLowerCase();
        var question = entry.question.toLowerCase();
        var answer = entry.answer.toLowerCase();
        var words = q.split(/\s+/).filter(function(w) { return w.length > 1; });
        var s = 0;
        if (question.includes(q)) s += 100;
        if (answer.includes(q)) s += 30;
        words.forEach(function(w) {
            if (question.includes(w)) s += 20;
            if (answer.includes(w)) s += 5;
        });
        // Bigram overlap
        var bigrams = function(str) {
            var b = [];
            for (var i = 0; i < str.length - 1; i++) b.push(str.slice(i, i + 2));
            return b;
        };
        var qb = bigrams(q), tb = bigrams(question);
        if (qb.length > 0) {
            var overlap = qb.filter(function(bg) { return tb.indexOf(bg) !== -1; }).length;
            s += Math.round((overlap / qb.length) * 25);
        }
        return s;
    }

    function clearSearch(container) {
        var results = container.querySelector('.cs-search-results');
        var clearBtn = container.querySelector('.cs-search-clear');
        if (results) results.style.display = 'none';
        if (clearBtn) clearBtn.style.display = 'none';
    }

    function init() {
        buildIndex();
        document.querySelectorAll('.cs-search-input').forEach(function(input) {
            var container = input.closest('.cs-search-container');
            var results = container.querySelector('.cs-search-results');
            var clearBtn = container.querySelector('.cs-search-clear');
            var timer;

            input.addEventListener('input', function() {
                clearTimeout(timer);
                var query = input.value.trim();
                if (query.length < 2) { clearSearch(container); return; }
                clearBtn.style.display = 'flex';
                timer = setTimeout(function() {
                    var scored = faqIndex
                        .map(function(e) { return { entry: e, score: score(e, query) }; })
                        .filter(function(r) { return r.score >= 10; })
                        .sort(function(a, b) { return b.score - a.score; })
                        .slice(0, 8);
                    results.style.display = 'block';
                    if (scored.length === 0) {
                        results.innerHTML = '<div class="cs-search-empty"><p>Geen resultaten gevonden.</p><p class="cs-search-empty-sub">Probeer andere zoekwoorden of <button onclick="showSection(\'contact\')" style="color:var(--primary-orange);background:none;border:none;cursor:pointer;font-weight:600;padding:0">neem contact op</button>.</p></div>';
                        return;
                    }
                    results.innerHTML = scored.map(function(r) {
                        return '<div class="cs-search-result-item" data-section="' + r.entry.sectionId + '" data-faq-id="' + r.entry.element.id + '">' +
                            '<div class="cs-search-result-header"><span class="cs-search-result-tag">' + r.entry.sectionLabel + '</span>' +
                            '<span class="cs-search-result-question">' + r.entry.question + '</span></div>' +
                            '<p class="cs-search-result-preview">' + r.entry.answer.substring(0, 120) + (r.entry.answer.length > 120 ? '…' : '') + '</p></div>';
                    }).join('');
                    results.querySelectorAll('.cs-search-result-item').forEach(function(item) {
                        item.addEventListener('click', function() {
                            var sid = item.getAttribute('data-section');
                            var fid = item.getAttribute('data-faq-id');
                            // Clear all search inputs
                            document.querySelectorAll('.cs-search-input').forEach(function(i) { i.value = ''; });
                            document.querySelectorAll('.cs-search-container').forEach(function(c) { clearSearch(c); });
                            showSection(sid);
                            setTimeout(function() {
                                var faqEl = document.getElementById(fid);
                                if (faqEl) {
                                    if (!faqEl.classList.contains('active')) {
                                        faqEl.classList.add('active');
                                        animateFaqOpen(faqEl.querySelector('.faq-answer'));
                                    }
                                    faqEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                }
                            }, 200);
                        });
                    });
                }, 150);
            });

            clearBtn.addEventListener('click', function() {
                input.value = '';
                clearSearch(container);
                input.focus();
            });
        });

        // Close all search dropdowns and tooltips when clicking outside
        document.addEventListener('click', function(e) {
            document.querySelectorAll('.cs-search-container').forEach(function(container) {
                if (!container.contains(e.target)) {
                    clearSearch(container);
                    var input = container.querySelector('.cs-search-input');
                    if (input) input.value = '';
                }
            });
            
            // Close order tooltip
            var tooltip = document.getElementById('orderTooltip');
            var infoBtn = e.target.closest('.lookup-info-btn');
            if (tooltip && tooltip.classList.contains('is-visible') && !infoBtn && !tooltip.contains(e.target)) {
                tooltip.classList.remove('is-visible');
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// Interactive Timeline Observer
document.addEventListener('DOMContentLoaded', function() {
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.15
    };

    const timelineObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
            }
        });
    }, observerOptions);

    const observeTimeline = () => {
        document.querySelectorAll('.aux-timeline-item').forEach(item => {
            timelineObserver.observe(item);
        });
    };

    // Run once on load
    observeTimeline();
});

// Also handle window load event for Shopify compatibility
window.addEventListener('load', function() {
    if (window.location.hash) {
        var event = new Event('hashchange');
        window.dispatchEvent(event);
    } else {
        window.scrollTo(0, 0);
    }
});

// Invoice download function - generates printable invoice
window.downloadInvoice = function(orderNumber, orderDate, locale) {
    // Get the current order data from the results div
    const orderCard = document.querySelector('.order-card');
    if (!orderCard) return;

    // Track invoice download
    fetch('https://bwj-customer-service.replit.app/api/analytics/invoice-download', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ store: 'nl' })
    }).catch(() => {});

    // Extract data from the displayed order
    const orderNumberText = orderCard.querySelector('.order-number')?.textContent || orderNumber;
    const totalValue = orderCard.querySelector('.order-total-value')?.textContent || '';
    const statusBadge = orderCard.querySelector('.order-status-badge')?.textContent || '';
    const paymentStatus = orderCard.querySelectorAll('.order-detail-value')[0]?.textContent || '';
    const carrier = orderCard.querySelectorAll('.order-detail-value')[1]?.textContent || '';
    const shippingTo = orderCard.querySelectorAll('.order-detail-value')[2]?.textContent || '';
    const contactEmail = orderCard.querySelectorAll('.order-detail-value')[3]?.textContent || '';

    // Get customer data from the order card data attributes
    const customerName = orderCard.getAttribute('data-customer-name') || '';
    const customerPhone = orderCard.getAttribute('data-phone') || '';

    // Get financial breakdown data
    const subtotalValue = orderCard.getAttribute('data-subtotal') || '0.00';
    const taxValue = orderCard.getAttribute('data-tax') || '0.00';
    const discountsValue = orderCard.getAttribute('data-discounts') || '0.00';
    const shippingCostValue = orderCard.getAttribute('data-shipping-cost') || '0.00';
    const grandTotalValue = orderCard.getAttribute('data-total') || '0.00';
    const currencySymbol = orderCard.getAttribute('data-currency') || '€';
    const taxesIncluded = orderCard.getAttribute('data-taxes-included') === 'true';

    // Parse tax lines for detailed breakdown
    let taxLines = [];
    try {
        const taxLinesJSON = orderCard.getAttribute('data-tax-lines');
        if (taxLinesJSON) {
            taxLines = JSON.parse(taxLinesJSON);
        }
    } catch (e) {
        console.error('Error parsing tax lines:', e);
    }

    // Parse address data from JSON attributes
    let shippingAddress = null;
    let billingAddress = null;
    try {
        const shippingJSON = orderCard.getAttribute('data-shipping-address');
        if (shippingJSON) {
            shippingAddress = JSON.parse(shippingJSON.replace(/&quot;/g, '"'));
        }
        const billingJSON = orderCard.getAttribute('data-billing-address');
        if (billingJSON) {
            billingAddress = JSON.parse(billingJSON.replace(/&quot;/g, '"'));
        }
    } catch (e) {
        console.error('Error parsing address data:', e);
    }

    // Get line items
    const itemElements = orderCard.querySelectorAll('.order-item');
    let itemsHTML = '';
    itemElements.forEach(item => {
        const name = item.querySelector('.order-item-name')?.textContent || '';
        const title = item.querySelector('.order-item-title')?.textContent || '';
        const itemTitle = title || name;
        const qty = item.querySelector('.order-item-qty')?.textContent || '';
        const price = item.querySelector('.order-item-price')?.textContent || '';
        itemsHTML += `
            <tr>
                <td>${itemTitle}</td>
                <td style="text-align: center;">${qty.replace('Qty: ', '')}</td>
                <td style="text-align: right; font-weight: 600;">${price}</td>
            </tr>
        `;
    });

    const t = translations[locale] || translations['nl-NL'];
    const invoiceDate = new Date().toLocaleDateString(locale);

    // Country-specific logos
    const countryLogos = {
        'UK': 'https://cdn.shopify.com/s/files/1/0879/7120/1300/files/sws_logo_horizontal_small_rgb.png?v=1729582729',
        'GB': 'https://cdn.shopify.com/s/files/1/0879/7120/1300/files/sws_logo_horizontal_small_rgb.png?v=1729582729',
        'NL': 'https://cdn.shopify.com/s/files/1/0879/7120/1300/files/swb_logo_horizontal_small_rgb.png?v=1725620750',
        'BE': 'https://cdn.shopify.com/s/files/1/0879/7120/1300/files/swb_logo_horizontal_small_rgb.png?v=1725620750'
    };

    // Normalize country name to ISO code
    const normalizeCountry = (countryStr) => {
        if (!countryStr) return '';
        const normalized = countryStr.toUpperCase().trim();

        // Map full country names to ISO codes
        const countryNameMap = {
            'UNITED KINGDOM': 'GB',
            'GREAT BRITAIN': 'GB',
            'ENGLAND': 'GB',
            'SCOTLAND': 'GB',
            'WALES': 'GB',
            'GERMANY': 'DE',
            'DEUTSCHLAND': 'DE',
            'NETHERLANDS': 'NL',
            'NEDERLAND': 'NL',
            'BELGIUM': 'BE',
            'BELGIË': 'BE',
            'BELGIQUE': 'BE',
            'SPAIN': 'ES',
            'ESPAÑA': 'ES',
            'FRANCE': 'FR'
        };

        // Check if it's a full country name first
        if (countryNameMap[normalized]) {
            return countryNameMap[normalized];
        }

        // Otherwise return as-is (might already be an ISO code)
        return normalized;
    };

    // Detect country from shipping address (Shopify uses countryCodeV2)
    const rawCountry = shippingAddress?.countryCodeV2 || shippingAddress?.countryCode || shippingAddress?.country_code || shippingAddress?.country || '';
    const country = normalizeCountry(rawCountry);
    const logoURL = countryLogos[country];

    // Debug logging
    console.log('Invoice country detection:', { rawCountry, country, logoURL });

    // HTML escape helper to prevent XSS
    const escapeHTML = (str) => {
        if (!str) return '';
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    };

    // Format address for display (with HTML escaping)
    const formatAddress = (addr) => {
        if (!addr) return '';
        const parts = [];
        if (addr.address1) parts.push(escapeHTML(addr.address1));
        if (addr.address2) parts.push(escapeHTML(addr.address2));
        const cityLine = [addr.city, addr.province, addr.zip].filter(Boolean).map(escapeHTML).join(', ');
        if (cityLine) parts.push(cityLine);
        if (addr.country) parts.push(escapeHTML(addr.country));
        return parts.filter(Boolean).join('<br>');
    };

    // Build shipping address HTML
    let shippingAddressHTML = '';
    if (shippingAddress) {
        const fullName = [shippingAddress.firstName, shippingAddress.lastName].filter(Boolean).map(escapeHTML).join(' ');
        const phone = escapeHTML(shippingAddress.phone || customerPhone);
        const addressFormatted = formatAddress(shippingAddress);
        shippingAddressHTML = `
            ${shippingAddress.company ? `<p><strong>${t.company || 'Bedrijf'}:</strong> ${escapeHTML(shippingAddress.company)}</p>` : ''}
            ${fullName ? `<p><strong>Name:</strong> ${fullName}</p>` : ''}
            ${addressFormatted ? `<p><strong>Address:</strong><br>${addressFormatted}</p>` : `<p><strong>Ship to:</strong> ${escapeHTML(shippingTo)}</p>`}
            ${phone ? `<p><strong>Phone:</strong> ${phone}</p>` : ''}
            <p><strong>Email:</strong> ${escapeHTML(contactEmail)}</p>
        `;
    } else {
        shippingAddressHTML = `
            ${customerName ? `<p><strong>Customer:</strong> ${escapeHTML(customerName)}</p>` : ''}
            <p><strong>${t.shippingTo}:</strong> ${escapeHTML(shippingTo)}</p>
            ${customerPhone ? `<p><strong>Phone:</strong> ${escapeHTML(customerPhone)}</p>` : ''}
            <p><strong>Email:</strong> ${escapeHTML(contactEmail)}</p>
        `;
    }

    // Build billing address HTML
    let billingAddressHTML = '';
    if (billingAddress) {
        const fullName = [billingAddress.firstName, billingAddress.lastName].filter(Boolean).map(escapeHTML).join(' ');
        const phone = escapeHTML(billingAddress.phone || customerPhone);
        billingAddressHTML = `
            <div class="info-section">
                <h3>Factuurgegevens</h3>
                ${billingAddress.company ? `<p><strong>${t.company || 'Bedrijf'}:</strong> ${escapeHTML(billingAddress.company)}</p>` : ''}
                ${fullName ? `<p><strong>Name:</strong> ${fullName}</p>` : ''}
                ${formatAddress(billingAddress) ? `<p><strong>Address:</strong><br>${formatAddress(billingAddress)}</p>` : ''}
                ${phone ? `<p><strong>Phone:</strong> ${phone}</p>` : ''}
                <p><strong>Email:</strong> ${escapeHTML(contactEmail)}</p>
            </div>
        `;
    }

    // Create invoice HTML
    const invoiceHTML = `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">
            <title>Invoice - ${orderNumberText}</title>
            <style>
                * { margin: 0; padding: 0; box-sizing: border-box; }
                body {
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
                    padding: 2rem;
                    background: #F8FAFC;
                }
                .invoice-container {
                    max-width: 800px;
                    margin: 0 auto;
                    background: white;
                    padding: 2rem;
                    border-radius: 12px;
                    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
                }
                .invoice-disclaimer {
                    background: #FFF9F5;
                    border-left: 4px solid #FF4F01;
                    padding: 0.75rem 1rem;
                    margin-bottom: 1.5rem;
                    border-radius: 6px;
                }
                .invoice-disclaimer p {
                    font-size: 0.8rem;
                    color: #64748B;
                    font-style: italic;
                }
                .invoice-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 1.5rem;
                    padding-bottom: 1.5rem;
                    border-bottom: 3px solid #FF4F01;
                }
                .company-logo {
                    max-width: 200px;
                    height: auto;
                    margin-bottom: 0.5rem;
                }
                .company-info h1 {
                    font-size: 1.75rem;
                    color: #FF4F01;
                    margin-bottom: 0.25rem;
                }
                .company-info p {
                    color: #64748B;
                    line-height: 1.4;
                    font-size: 0.875rem;
                }
                .invoice-details {
                    text-align: right;
                }
                .invoice-details h2 {
                    font-size: 1.5rem;
                    color: #0F172A;
                    margin-bottom: 0.5rem;
                }
                .invoice-details p {
                    color: #64748B;
                    line-height: 1.8;
                }
                .order-info {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 1rem;
                    margin-bottom: 1.5rem;
                    padding: 1rem;
                    background: #F8FAFC;
                    border-radius: 8px;
                }
                .info-section h3 {
                    font-size: 0.75rem;
                    color: #64748B;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    margin-bottom: 0.5rem;
                }
                .info-section p {
                    color: #0F172A;
                    line-height: 1.5;
                    font-size: 0.875rem;
                    margin-bottom: 0.25rem;
                }
                .items-table {
                    width: 100%;
                    margin-bottom: 1rem;
                    border-collapse: collapse;
                }
                .items-table thead {
                    background: linear-gradient(135deg, #FF4F01, #FF6B2B);
                    color: white;
                }
                .items-table th {
                    padding: 0.75rem;
                    text-align: left;
                    font-weight: 600;
                    font-size: 0.8rem;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                }
                .items-table th:nth-child(2) { text-align: center; }
                .items-table th:nth-child(3) { text-align: right; }
                .items-table td {
                    padding: 0.5rem 0.75rem;
                    font-size: 0.875rem;
                }
                .invoice-totals {
                    margin-top: 1.5rem;
                    padding: 1rem;
                    background: #F8FAFC;
                    border-radius: 8px;
                }
                .totals-table {
                    width: 100%;
                    max-width: 350px;
                    margin-left: auto;
                    border-collapse: collapse;
                }
                .totals-table td {
                    padding: 0.5rem 0;
                    font-size: 0.95rem;
                    color: #475569;
                }
                .totals-table td.amount {
                    text-align: right;
                    font-weight: 600;
                    color: #0F172A;
                }
                .totals-table .discount-row td {
                    color: #16a34a;
                }
                .totals-table .grand-total-row td {
                    padding-top: 0.75rem;
                    border-top: 2px solid #E2E8F0;
                    font-size: 1.1rem;
                    font-weight: 700;
                    color: #0F172A;
                }
                .totals-table .grand-total-row td.amount {
                    color: #FF4F01;
                    font-size: 1.25rem;
                }
                .invoice-footer {
                    margin-top: 1.5rem;
                    padding-top: 1rem;
                    border-top: 1px solid #E2E8F0;
                    text-align: center;
                    color: #64748B;
                    font-size: 0.8rem;
                }

                /* Mobile Responsive Styles */
                @media screen and (max-width: 768px) {
                    body {
                        padding: 0.5rem;
                    }
                    .invoice-container {
                        padding: 1rem;
                        border-radius: 8px;
                    }
                    .invoice-disclaimer {
                        padding: 0.5rem 0.75rem;
                        margin-bottom: 1rem;
                    }
                    .invoice-disclaimer p {
                        font-size: 0.75rem;
                    }
                    .invoice-header {
                        flex-direction: column;
                        gap: 1rem;
                        margin-bottom: 1rem;
                        padding-bottom: 1rem;
                    }
                    .company-logo {
                        max-width: 150px;
                    }
                    .company-info h1 {
                        font-size: 1.25rem;
                    }
                    .company-info p {
                        font-size: 0.8rem;
                    }
                    .invoice-details {
                        text-align: left;
                    }
                    .invoice-details h2 {
                        font-size: 1.25rem;
                    }
                    .invoice-details p {
                        font-size: 0.8rem;
                    }
                    .order-info {
                        grid-template-columns: 1fr !important;
                        gap: 1rem;
                        padding: 0.75rem;
                        margin-bottom: 1rem;
                    }
                    .info-section h3 {
                        font-size: 0.75rem;
                    }
                    .info-section p {
                        font-size: 0.8rem;
                    }
                    .items-table {
                        font-size: 0.8rem;
                    }
                    .items-table th {
                        padding: 0.5rem 0.25rem;
                        font-size: 0.7rem;
                    }
                    .items-table td {
                        padding: 0.4rem 0.25rem;
                        font-size: 0.8rem;
                    }
                    .invoice-totals {
                        padding: 0.75rem;
                    }
                    .totals-table {
                        max-width: 100%;
                    }
                    .totals-table td {
                        font-size: 0.85rem;
                    }
                    .totals-table .grand-total-row td.amount {
                        font-size: 1.1rem;
                    }
                    .invoice-footer {
                        margin-top: 1rem;
                        font-size: 0.75rem;
                    }
                }

                @media print {
                    body { background: white; padding: 0; }
                    .invoice-container { box-shadow: none; padding: 1.5rem; }
                    @page { margin: 1cm; }
                }
            </style>
        </head>
        <body>
            <div class="invoice-container">
                <div class="invoice-disclaimer">
                    <p><strong>Let op:</strong> Dit is een gegenereerde factuur voor je administratie. Je officiële factuur is naar je e-mailadres verzonden op het moment van aankoop.</p>
                </div>

                <div class="invoice-header">
                    <div class="company-info">
                        ${logoURL ? `<img src="${logoURL}" alt="Smartwatchbanden.nl" class="company-logo">` : '<h1>Smartwatchbanden.nl</h1>'}
                        <p>Premium Smartwatch Bandjes & Accessoires</p>
                        <p>service@smartwatchbanden.nl</p>
                    </div>
                    <div class="invoice-details">
                        <h2>${t.invoice || 'Invoice'}</h2>
                        <p><strong>${t.date || 'Date'}:</strong> ${invoiceDate}</p>
                        <p><strong>${t.orderNumber}:</strong> ${orderNumber}</p>
                    </div>
                </div>

                <div class="order-info">
                    <div class="info-section">
                        <h3>${t.orderDetails || 'Order Details'}</h3>
                        <p><strong>${t.placedOn}:</strong> ${orderDate}</p>
                        <p><strong>${t.status || 'Status'}:</strong> ${statusBadge}</p>
                        <p><strong>${t.paymentStatus}:</strong> ${paymentStatus}</p>
                        <p><strong>${t.carrier}:</strong> ${carrier}</p>
                    </div>
                    <div class="info-section">
                        <h3>${t.shippingDetails || 'Shipping Details'}</h3>
                        ${shippingAddressHTML}
                    </div>
                    ${billingAddressHTML}
                </div>

                <table class="items-table">
                    <thead>
                        <tr>
                            <th>${t.item || 'Item'}</th>
                            <th>${t.quantity || 'Quantity'}</th>
                            <th>${t.price || 'Price'}</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${itemsHTML}
                    </tbody>
                </table>

                <div class="invoice-totals">
                    <table class="totals-table">
                        <tbody>
                            <tr>
                                <td>${t.subtotal || 'Subtotaal'}</td>
                                <td class="amount">${currencySymbol}${parseFloat(subtotalValue).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>${t.shipping || 'Verzendkosten'}</td>
                                <td class="amount">${currencySymbol}${parseFloat(shippingCostValue).toFixed(2)}</td>
                            </tr>
                            ${parseFloat(discountsValue) > 0 ? `
                            <tr class="discount-row">
                                <td>${t.discount || 'Korting'}</td>
                                <td class="amount">-${currencySymbol}${parseFloat(discountsValue).toFixed(2)}</td>
                            </tr>
                            ` : ''}
                            ${taxLines.length > 0 ? taxLines.map(line => `
                            <tr>
                                <td>${line.title}${line.ratePercentage ? ` (${line.ratePercentage}%)` : ''}${taxesIncluded ? ' (inbegrepen)' : ''}</td>
                                <td class="amount">${currencySymbol}${parseFloat(line.price).toFixed(2)}</td>
                            </tr>
                            `).join('') : `
                            <tr>
                                <td>${t.tax || 'BTW'}${taxesIncluded ? ' (inbegrepen)' : ''}</td>
                                <td class="amount">${currencySymbol}${parseFloat(taxValue).toFixed(2)}</td>
                            </tr>
                            `}
                            <tr class="grand-total-row">
                                <td>${t.grandTotal || 'Totaalbedrag'}</td>
                                <td class="amount">${currencySymbol}${parseFloat(grandTotalValue).toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="invoice-footer">
                    <p>${t.thankYou || 'Bedankt voor je bestelling!'}</p>
                    <p style="margin-top: 1rem;">Smartwatchbanden.nl © ${new Date().getFullYear()}</p>
                </div>
            </div>
        </body>
        </html>
    `;

    // Open invoice in new window and trigger print
    const invoiceWindow = window.open('', '_blank');
    if (invoiceWindow) {
        invoiceWindow.document.write(invoiceHTML);
        invoiceWindow.document.close();

        // Trigger print after content loads
        invoiceWindow.onload = function() {
            invoiceWindow.print();
        };
    } else {
        alert(t.popupBlocked || 'Please allow popups to download the invoice');
    }
};

// Helper function to generate carrier-specific tracking URL
function getTrackingUrl(carrier, trackingNumber, postcode) {
    // Try to find exact carrier match
    let carrierConfig = carrierRegistry[carrier];

    // If not found, try case-insensitive search
    if (!carrierConfig) {
        const carrierKey = Object.keys(carrierRegistry).find(
            key => key.toLowerCase() === carrier.toLowerCase()
        );
        if (carrierKey) {
            carrierConfig = carrierRegistry[carrierKey];
        }
    }

    if (carrierConfig && carrierConfig.urlTemplate) {
        try {
            return carrierConfig.urlTemplate(trackingNumber, postcode);
        } catch (error) {
            console.warn('Error generating tracking URL:', error);
        }
    }

    // Fallback to Royal Mail if carrier not found or URL generation fails
    return `https://www.royalmail.com/track-your-item#/tracking-results/${encodeURIComponent(trackingNumber)}`;
}

window.lookupOrder = async function() {
    const orderNumber = document.getElementById('orderNumber').value.trim();
    const orderEmail = document.getElementById('orderEmail').value.trim();
    const resultsDiv = document.getElementById('orderResults');
    const lookupBtn = document.getElementById('lookupBtn');

    if (!orderNumber || !orderEmail) return;

    // Use API_ENDPOINT if defined in template, otherwise use hardcoded URL
    const apiUrl = typeof API_ENDPOINT !== 'undefined' ? API_ENDPOINT : 'https://actium.automagically.nl/webhook/track-order';
    console.log('Looking up order:', orderNumber, 'with API:', apiUrl);

    // Use English for loading state initially (will be replaced with locale-specific once we get response)
    const loadingText = translations['en-GB'].searching;
    lookupBtn.disabled = true;
    lookupBtn.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation: spin 1s linear infinite;"><circle cx="12" cy="12" r="10" opacity="0.25"></circle><path d="M4 12a8 8 0 0 1 8-8" opacity="0.75"></path></svg> ${loadingText}`;

    try {
        console.log('Fetching from API...');
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ orderNumber, email: orderEmail, country: 'NL' })
        });

        const data = await response.json();

        // Get translations for the detected locale (or fallback to English for errors)
        const locale = data.locale || 'en-GB';
        const t = translations[locale] || translations['en-GB'];

        // Trigger error handler if response isn't OK, OR if n8n returns an error JSON payload
        if (!response.ok || data.error) {
            // Log server error for debugging but show localized message to user
            if (data.error) {
                console.log('Server error:', data.error);
            }

            // Dynamically select the correct localized error text based on the errorType from n8n
            const errorText = data.errorType === 'connection' ? t.connectionError : t.orderNotFound;

            resultsDiv.innerHTML = `
                <div class="order-error">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                    <p>${errorText}</p>
                </div>
            `;
            resultsDiv.style.display = 'block';

            // Reset button with correct locale
            lookupBtn.disabled = false;
            lookupBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                </svg>
                ${t.findMyOrder}
            `;
            return;
        }

        // Track successful order search
        fetch('https://bwj-customer-service.replit.app/api/analytics/order-search', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ store: 'nl' })
        }).catch(() => {});

        const currencySymbol = data.currencySymbol || '€';

        // Override carrier name based on shipping country for local carrier display
        const getLocalCarrierName = (apiCarrier, countryCode, country) => {
            const code = (countryCode || '').toUpperCase().trim();
            const countryName = (country || '').toLowerCase().trim();

            // Belgium -> Bpost
            if (code === 'BE' || countryName.includes('belgium') || countryName.includes('belgi')) {
                return 'Bpost';
            }
            // Netherlands -> PostNL
            if (code === 'NL' || countryName.includes('netherlands') || countryName.includes('nederland')) {
                return 'PostNL';
            }
            // Germany -> Deutsche Post
            if (code === 'DE' || countryName.includes('germany') || countryName.includes('deutschland')) {
                return 'Deutsche Post';
            }
            // Spain -> Correos
            if (code === 'ES' || countryName.includes('spain') || countryName.includes('españa')) {
                return 'Correos';
            }
            // France -> La Poste
            if (code === 'FR' || countryName.includes('france')) {
                return 'La Poste';
            }
            // UK/Ireland -> Royal Mail
            if (code === 'GB' || code === 'UK' || code === 'IE' || 
                countryName.includes('united kingdom') || countryName.includes('ireland')) {
                return 'Royal Mail';
            }
            // Fallback to API carrier name
            return apiCarrier;
        };

        const displayCarrier = getLocalCarrierName(
            data.carrier, 
            data.shippingAddress?.countryCode, 
            data.shippingAddress?.country
        );

        const statusClass = data.status === 'Shipped' ? 'status-shipped' : 
                          data.status === 'Processing' ? 'status-processing' : 'status-pending';

        // Translate status
        const statusMap = {
            'Shipped': t.shipped,
            'Processing': t.processing,
            'Pending Payment': t.pending
        };
        const translatedStatus = statusMap[data.status] || data.status;

        // Translate financial status
        const financialStatusMap = {
            'Paid': t.paid,
            'Unpaid': t.unpaid,
            'Refunded': t.refunded,
            'Pending': t.pending
        };
        const translatedFinancialStatus = financialStatusMap[data.financialStatus] || data.financialStatus;

        // Helper function to check if tracking number is missing or invalid
        const hasValidTracking = (trackingNum) => {
            if (!trackingNum) return false;
            const normalized = String(trackingNum).trim().toLowerCase();
            const invalidSentinels = [
                'not yet shipped',
                'not available',
                'no tracking provided',
                'pending',
                'n/a',
                'none',
                ''
            ];
            return !invalidSentinels.includes(normalized);
        };

        // Determine tracking display (button or status message)
        let trackingButtonHTML = '';

        if (hasValidTracking(data.trackingNumber)) {
            // Has valid tracking - show tracking button
            const trackingUrl = getTrackingUrl(displayCarrier, data.trackingNumber, data.shippingAddress?.zip);
            trackingButtonHTML = `<a href="${trackingUrl}" target="_blank" rel="noopener noreferrer" class="lookup-btn" style="padding: 0.625rem 1.25rem; font-size: 0.9375rem; white-space: nowrap;"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 18px; height: 18px;"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>${t.trackPackage}</a>`;
        } else {
            // No valid tracking - determine appropriate message based on fulfillment status
            const messageText = (data.status === 'Shipped') 
                ? (t.untrackedDelivery || 'Your order has been dispatched and is on its way to you.')
                : (t.trackingAvailableSoon || 'Tracking will be available soon');

            trackingButtonHTML = `<div class="tracking-status-message" style="padding: 0.5rem 0.875rem; font-size: 0.8125rem; color: #FF4F01; background: rgba(255, 255, 255, 0.95); font-weight: 600; border-radius: 12px; max-width: 280px; overflow-wrap: break-word; word-wrap: break-word; hyphens: auto; box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); line-height: 1.35;">${messageText}</div>`;
        }

        const itemsHTML = data.lineItems.map(item => `
            <div class="order-item">
                <div>
                    <div class="order-item-name">${item.translatedName || item.title || item.name}</div>
                    <span class="order-item-qty">${t.qty}: ${item.quantity}</span>
                </div>
                <div class="order-item-price">${currencySymbol}${parseFloat(item.price).toFixed(2)}</div>
            </div>
        `).join('');

        let shippingHTML = '';
        if (data.shippingAddress) {
            shippingHTML = `
                <div class="order-detail">
                    <div class="order-detail-label">${t.shippingTo}</div>
                    <div class="order-detail-value">${data.shippingAddress.city}, ${data.shippingAddress.country}</div>
                </div>
            `;
        }

        const customerFullName = data.shippingAddress && data.shippingAddress.firstName && data.shippingAddress.lastName ? 
            `${data.shippingAddress.firstName} ${data.shippingAddress.lastName}` : '';
        const escapedCustomerName = customerFullName.replace(/"/g, '&quot;');

        // Check if invoice download should be available (UK, NL, BE orders) - case-insensitive
        const shippingCountry = (data.shippingAddress?.country || '').toLowerCase().trim();
        const shippingCountryCode = (data.shippingAddress?.countryCode || '').toUpperCase().trim();
        const isInvoiceAvailable = shippingCountry.includes('united kingdom') || 
                          shippingCountry.includes('england') || 
                          shippingCountry.includes('scotland') || 
                          shippingCountry.includes('wales') || 
                          shippingCountry.includes('northern ireland') ||
                          shippingCountry.includes('netherlands') ||
                          shippingCountry.includes('nederland') ||
                          shippingCountry.includes('belgium') ||
                          shippingCountry.includes('belgi') ||
                          shippingCountryCode === 'GB' || 
                          shippingCountryCode === 'UK' ||
                          shippingCountryCode === 'NL' ||
                          shippingCountryCode === 'BE';

        // Helper function to add working days (excludes weekends)
        const addWorkingDays = (date, days) => {
            const result = new Date(date);
            let addedDays = 0;
            while (addedDays < days) {
                result.setDate(result.getDate() + 1);
                // Skip weekends (0 = Sunday, 6 = Saturday)
                if (result.getDay() !== 0 && result.getDay() !== 6) {
                    addedDays++;
                }
            }
            result.setHours(0, 0, 0, 0);
            return result;
        };

        // Calculate delivery prediction if we have a ship date
        let deliveryPredictionHTML = '';
        console.log('Ship date from API:', data.shipDate);
        console.log('Order data:', data);

        // Determine if shipping to NL or Belgium for delivery estimates
        const isNetherlandsOrder = shippingCountry.includes('netherlands') || 
                                   shippingCountry.includes('nederland') || 
                                   shippingCountryCode === 'NL';
        const isBelgiumOrder = shippingCountry.includes('belgium') || 
                               shippingCountry.includes('belgi') || 
                               shippingCountryCode === 'BE';

        if (data.shipDate) {
            console.log('Ship date exists, calculating prediction');
            const shipDate = new Date(data.shipDate);
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Reset time for date-only comparison

            // Calculate delivery dates based on destination
            // NL: Next day delivery (1 working day), skip Sunday and Monday
            // BE: 2-4 working days (Promise fast, but delay red error to protect CS)
            // Other: 2-4 working days (default)

            // Helper to add days skipping Sunday and Monday (PostNL doesn't deliver)
            const addNLDeliveryDays = (date, days) => {
                const result = new Date(date);
                let addedDays = 0;
                while (addedDays < days) {
                    result.setDate(result.getDate() + 1);
                    // Skip Sunday (0) and Monday (1) - PostNL doesn't deliver
                    if (result.getDay() !== 0 && result.getDay() !== 1) {
                        addedDays++;
                    }
                }
                result.setHours(0, 0, 0, 0);
                return result;
            };

            let earliestDate, latestDate;
            if (isNetherlandsOrder) {
                // NL: Usually next day (1 working day, skipping Sun/Mon)
                earliestDate = addNLDeliveryDays(shipDate, 1);
                latestDate = addNLDeliveryDays(shipDate, 2); // Allow 1 extra day buffer
            } else if (isBelgiumOrder) {
                // Belgium: Tell customer 2-4 working days initially
                earliestDate = addWorkingDays(shipDate, 2);
                latestDate = addWorkingDays(shipDate, 4);
            } else {
                // Default: 2-4 working days
                earliestDate = addWorkingDays(shipDate, 2);
                latestDate = addWorkingDays(shipDate, 4);
            }

            // Buffer before showing YELLOW "Slight delay" notification
            // BE triggers at 5 days (pushing the dynamic dates to keep them calm), NL at 4 days, others at 6
            let delayedNotificationDate;
            if (isNetherlandsOrder) { delayedNotificationDate = addNLDeliveryDays(shipDate, 4); }
            else if (isBelgiumOrder) { delayedNotificationDate = addWorkingDays(shipDate, 5); }
            else { delayedNotificationDate = addWorkingDays(shipDate, 6); }

            // Extended window for RED "significantly delayed" / contact us message
            // 14 working days for BE protects CS from spam (~3 real weeks)
            let delayedThreshold;
            if (isNetherlandsOrder) { delayedThreshold = addNLDeliveryDays(shipDate, 8); }
            else if (isBelgiumOrder) { delayedThreshold = addWorkingDays(shipDate, 14); }
            else { delayedThreshold = addWorkingDays(shipDate, 10); }

            // Check if order has been delivered (from Shopify, Ship24, or Gearchiveerd tag)
            const hasArchivedTag = data.tags && data.tags.includes('Gearchiveerd');
            const isDelivered = data.shipmentStatus === 'delivered' || hasArchivedTag;

            // Format dates with day name and date (locale-aware)
            const formatDateWithDay = (date) => {
                const daysNL = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];
                const monthsNL = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];
                const daysEN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                const monthsEN = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

                const days = locale === 'nl-NL' ? daysNL : daysEN;
                const months = locale === 'nl-NL' ? monthsNL : monthsEN;
                const dayName = days[date.getDay()];
                const day = date.getDate();
                const month = months[date.getMonth()];
                return `${day} ${month} ${dayName}`;
            };

            const earliestFormatted = formatDateWithDay(earliestDate);
            const latestFormatted = formatDateWithDay(latestDate);

            // Helper function to check if current month is a busy shopping season
            const isBusyShoppingSeason = () => {
                const currentDate = new Date();
                const month = currentDate.getMonth(); // 0-indexed (0 = January, 11 = December)
                // Busy months: November (10), December (11), January (0)
                return month === 10 || month === 11 || month === 0;
            };

            // Seasonal delay message for busy shopping months (Dutch)
            const seasonalMessage = isBusyShoppingSeason() ? `
                <div class="delivery-prediction__seasonal">
                    <div class="delivery-prediction__seasonal-header">
                        <svg viewBox="0 0 24 24" fill="none" stroke-width="2">
                            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                        </svg>
                        <p class="delivery-prediction__seasonal-title">Feestdagen Melding</p>
                    </div>
                    <p class="delivery-prediction__seasonal-body">Door drukte tijdens de feestdagen kunnen sommige leveringen lichte vertragingen oplopen. Bedankt voor je geduld!</p>
                </div>
            ` : '';

            // Determine what to show based on timing and delivery status
            if (isDelivered) {
                // Package has been delivered - don't show any prediction box
                deliveryPredictionHTML = '';
            } else if (data.financialStatus === 'Refunded' || data.financialStatus === 'partially_refunded' || data.status === 'Cancelled') {
                // Order is refunded or cancelled - don't show prediction box
                deliveryPredictionHTML = '';
            } else if (today > delayedThreshold || (isNetherlandsOrder && today > delayedNotificationDate)) {
                // Tijdgebaseerde aanname: Het pakket zou inmiddels ruim bezorgd moeten zijn.
                // We tonen een groene "Check-in" status in plaats van een rode foutmelding.
                const trackingUrl = getTrackingUrl(displayCarrier, data.trackingNumber, data.shippingAddress?.zip);
                
                deliveryPredictionHTML = `
                    <div class="delivery-prediction delivery-prediction--success-assumed" style="background: linear-gradient(135deg, #F0FDF4 0%, #DCFCE7 100%); border: 2px solid rgba(16, 185, 129, 0.2);">
                        <div class="delivery-prediction__header">
                            <svg viewBox="0 0 24 24" fill="none" stroke="#059669" stroke-width="2.5">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                            <h4 class="delivery-prediction__title" style="color: #065F46; font-size: 1.125rem;">Heb je je bestelling ontvangen?</h4>
                        </div>
                        <p class="delivery-prediction__body" style="color: #047857; margin-bottom: 1rem; font-size: 0.9375rem;">
                            Volgens onze planning is je bestelling inmiddels via <strong>${displayCarrier}</strong> bezorgd. We hopen dat je blij bent met je aankoop!
                        </p>
                        
                        ${hasValidTracking(data.trackingNumber) ? `
                        <div style="margin-bottom: 1.25rem;">
                            <a href="${trackingUrl}" target="_blank" rel="noopener noreferrer" style="display: inline-flex; align-items: center; gap: 0.5rem; background: white; color: #065F46; padding: 0.625rem 1rem; border-radius: 0.5rem; text-decoration: none; font-weight: 600; font-size: 0.875rem; border: 1px solid rgba(16, 185, 129, 0.3); box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 16px; height: 16px;">
                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                    <polyline points="15 3 21 3 21 9"></polyline>
                                    <line x1="10" y1="14" x2="21" y2="3"></line>
                                </svg>
                                Bekijk definitieve Track & Trace
                            </a>
                        </div>
                        ` : ''}

                        <p class="delivery-prediction__cta" style="border-top: 1px solid rgba(16, 185, 129, 0.2); padding-top: 0.875rem; color: #065F46; font-size: 0.875rem; margin: 0;">
                            <strong>Nog niets ontvangen?</strong> <a href="#contact" onclick="showSection('contact'); setTimeout(() => document.getElementById('order').focus(), 300); return false;" style="color: #047857; text-decoration: underline;">Laat het ons weten</a>, dan zoeken we het direct voor je uit.
                        </p>
                    </div>
                `;
            } else if (today > delayedNotificationDate) {
                const shipDateFormatted = formatDateWithDay(shipDate);
                
                // Smart dynamic date calculation: Prevent showing past dates as "new expectations"
                let dynamicEarliest = earliestDate;
                let dynamicLatest = addWorkingDays(latestDate, 2);

                if (today >= dynamicLatest) {
                    dynamicEarliest = addWorkingDays(today, 1);
                    dynamicLatest = addWorkingDays(today, 3);
                } else if (today >= dynamicEarliest) {
                    dynamicEarliest = addWorkingDays(today, 1);
                    if (dynamicLatest <= dynamicEarliest) {
                        dynamicLatest = addWorkingDays(dynamicEarliest, 2);
                    }
                }

                const extendedEarliestFormatted = formatDateWithDay(dynamicEarliest);
                const extendedLatestFormatted = formatDateWithDay(dynamicLatest);

                deliveryPredictionHTML = `
                    ${seasonalMessage}
                    <div class="delivery-prediction delivery-prediction--delayed">
                        <div class="delivery-prediction__header">
                            <svg viewBox="0 0 24 24" fill="none" stroke-width="2">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" y1="8" x2="12" y2="12"></line>
                                <line x1="12" y1="16" x2="12.01" y2="16"></line>
                            </svg>
                            <h4 class="delivery-prediction__title">Lichte Vertraging</h4>
                        </div>
                        <p class="delivery-prediction__body">
                            Je bestelling is helaas wat langer onderweg dan gepland. Door drukte of weersomstandigheden loopt de bezorging iets uit. Geen zorgen, je pakketje komt meestal binnen een paar dagen alsnog aan.
                        </p>
                        <div class="delivery-prediction__tags">
                            <span class="delivery-prediction__tag delivery-prediction__tag--muted">Verzonden: ${shipDateFormatted}</span>
                            <span class="delivery-prediction__tag delivery-prediction__tag--accent">Nieuwe Verwachting: ${extendedEarliestFormatted} - ${extendedLatestFormatted}</span>
                        </div>
                    </div>
                `;
            } else {
                // Within expected delivery window - show normal prediction with timeline
                const shipDateFormatted = formatDateWithDay(shipDate);

                // Determine which message and format to show based on destination
                let deliveryMessage = t.yourOrderShouldArrive;
                let deliveryNote = '';
                let arrivalLabel = t.estimatedArrival;
                let arrivalText = `${earliestFormatted} - ${latestFormatted}`;

                if (isNetherlandsOrder) {
                    deliveryMessage = t.yourOrderShouldArriveNL || t.yourOrderShouldArrive;
                    deliveryNote = t.nlDeliveryNote || '';
                    arrivalLabel = t.nlExpectedDelivery || t.estimatedArrival;
                    arrivalText = earliestFormatted; // NL shows single date (usually next day)
                } else if (isBelgiumOrder) {
                    deliveryMessage = t.yourOrderShouldArriveBE || t.yourOrderShouldArrive;
                    deliveryNote = t.beDeliveryNote || '';
                    arrivalLabel = t.beExpectedDelivery || t.estimatedArrival;
                }

                deliveryPredictionHTML = `
                    ${seasonalMessage}
                    <div class="delivery-prediction delivery-prediction--normal">
                        <div class="delivery-prediction__header">
                            <svg viewBox="0 0 24 24" fill="none" stroke-width="2">
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                <line x1="16" y1="2" x2="16" y2="6"></line>
                                <line x1="8" y1="2" x2="8" y2="6"></line>
                                <line x1="3" y1="10" x2="21" y2="10"></line>
                            </svg>
                            <h4 class="delivery-prediction__title">${t.estimatedDelivery}</h4>
                        </div>
                        <p class="delivery-prediction__body">${deliveryMessage}</p>
                        ${deliveryNote ? `<p class="delivery-prediction__note">${deliveryNote}</p>` : ''}
                        <div class="delivery-prediction__timeline" style="gap: 0.375rem;">
                            <div class="delivery-prediction__row">
                                <svg viewBox="0 0 24 24" fill="none" stroke="var(--primary-orange)" stroke-width="2" style="width:14px;height:14px;"><polyline points="9 18 15 12 9 6"></polyline></svg>
                                <span class="delivery-prediction__label">${arrivalLabel}</span>
                                <span class="delivery-prediction__value delivery-prediction__value--highlight">${arrivalText}</span>
                            </div>
                            <div class="delivery-prediction__row" style="opacity: 0.7; font-size: 0.8125rem;">
                                <svg viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2" style="width:14px;height:14px;"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                <span class="delivery-prediction__label">${t.orderFulfilled}</span>
                                <span class="delivery-prediction__value">${shipDateFormatted}</span>
                            </div>
                        </div>
                    </div>
                `;
            }
        }

        // Override delivery prediction if order is refunded or cancelled
        if (data.financialStatus === 'Refunded' || data.financialStatus === 'partially_refunded' || data.status === 'Cancelled') {
            const isRefund = data.financialStatus === 'Refunded' || data.financialStatus === 'partially_refunded';
            const titleText = isRefund ? 'Bestelling Terugbetaald' : 'Bestelling Geannuleerd';
            const bodyText = isRefund ? 'Deze bestelling is geannuleerd en het aankoopbedrag is succesvol teruggestort.' : 'Deze bestelling is geannuleerd.';
            
            deliveryPredictionHTML = `
                <div class="delivery-prediction" style="background: linear-gradient(135deg, #F3F4F6 0%, #E5E7EB 100%); border: 2px solid rgba(156, 163, 175, 0.3);">
                    <div class="delivery-prediction__header">
                        <svg viewBox="0 0 24 24" fill="none" stroke="#4B5563" stroke-width="2.5" style="width: 22px; height: 22px;">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="8" x2="12" y2="12"></line>
                            <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        </svg>
                        <h4 class="delivery-prediction__title" style="color: #374151; font-size: 1.125rem;">${titleText}</h4>
                    </div>
                    <p class="delivery-prediction__body" style="color: #4B5563; margin-bottom: 0; font-size: 0.9375rem;">${bodyText}</p>
                </div>
            `;
        }

        // Prepare address data for invoice (escape for JSON embedding in HTML attribute)
        const shippingAddressJSON = data.shippingAddress ? JSON.stringify(data.shippingAddress).replace(/"/g, '&quot;') : '';
        const billingAddressJSON = data.billingAddress ? JSON.stringify(data.billingAddress).replace(/"/g, '&quot;') : '';
        const customerPhone = (data.phone || '').replace(/"/g, '&quot;');

        // Format date dynamically based on locale
        let displayOrderDate = data.orderDate;
        try {
            if (data.orderDate) {
                const d = new Date(data.orderDate);
                if (!isNaN(d.getTime())) {
                    const months = locale === 'nl-NL' ? 
                        ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'] : 
                        ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                    displayOrderDate = `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
                }
            }
        } catch(e) {}

        resultsDiv.innerHTML = `
            <div class="order-card order-card--v2"
                data-financial-status="${data.financialStatus || ''}"
                data-order-status="${data.status || ''}"
                data-customer-name="${escapedCustomerName}"
                data-shipping-address="${shippingAddressJSON}"
                data-billing-address="${billingAddressJSON}"
                data-phone="${customerPhone}"
                data-subtotal="${data.subtotalPrice || '0.00'}"
                data-tax="${data.totalTax || '0.00'}"
                data-discounts="${data.totalDiscounts || '0.00'}"
                data-shipping-cost="${data.totalShippingPrice || '0.00'}"
                data-total="${data.totalPrice || '0.00'}"
                data-currency="${currencySymbol}"
                data-tax-lines='${JSON.stringify(data.taxLines || [])}'
                data-taxes-included="${data.taxesIncluded || false}">

                <div class="order-card-header-v2">
                    <div class="order-card-header-info">
                        <div class="order-number">${t.orderNumber} ${data.orderNumber}</div>
                        <div class="order-date">${t.placedOn}: ${displayOrderDate}</div>
                    </div>
                    <div class="order-card-header-actions">
                        <span class="order-status-badge order-status-badge--v2 ${statusClass}">${translatedStatus}</span>
                        ${trackingButtonHTML}
                    </div>
                </div>

                <div class="order-card-body-v2">
                    ${deliveryPredictionHTML}

                    <div class="order-details order-details--v2">
                        <div class="order-detail">
                            <div class="order-detail-label">${t.paymentStatus}</div>
                            <div class="order-detail-value">${translatedFinancialStatus}</div>
                        </div>
                        <div class="order-detail">
                            <div class="order-detail-label">${t.carrier}</div>
                            <div class="order-detail-value">${displayCarrier}</div>
                        </div>
                        ${shippingHTML}
                        <div class="order-detail">
                            <div class="order-detail-label">${t.contactEmail}</div>
                            <div class="order-detail-value" style="word-break: break-all; font-size: 0.875rem;">${data.email}</div>
                        </div>
                    </div>

                    <div class="order-mobile-tracking">
                        ${trackingButtonHTML}
                    </div>

                    <div class="order-items">
                        <h4>${t.orderItems} (${data.itemCount})</h4>
                        ${itemsHTML}
                        <div class="order-totals-breakdown">
                            <div class="breakdown-row">
                                <span class="breakdown-label">${t.subtotal || 'Subtotaal'}</span>
                                <span class="breakdown-value">${currencySymbol}${parseFloat(data.subtotalPrice || data.totalPrice).toFixed(2)}</span>
                            </div>
                            <div class="breakdown-row">
                                <span class="breakdown-label">${t.shipping || 'Verzendkosten'}</span>
                                <span class="breakdown-value">${currencySymbol}${parseFloat(data.totalShippingPrice || '0.00').toFixed(2)}</span>
                            </div>
                            ${parseFloat(data.totalDiscounts || 0) > 0 ? `
                            <div class="breakdown-row discount-row">
                                <span class="breakdown-label">${t.discount || 'Korting'}</span>
                                <span class="breakdown-value">-${currencySymbol}${parseFloat(data.totalDiscounts).toFixed(2)}</span>
                            </div>
                            ` : ''}
                            ${(data.taxLines && data.taxLines.length > 0) ? data.taxLines.map(line => `
                            <div class="breakdown-row">
                                <span class="breakdown-label">${line.title}${line.ratePercentage ? ` (${line.ratePercentage}%)` : ''}${data.taxesIncluded ? ' (inbegrepen)' : ''}</span>
                                <span class="breakdown-value">${currencySymbol}${parseFloat(line.price).toFixed(2)}</span>
                            </div>
                            `).join('') : `
                            <div class="breakdown-row">
                                <span class="breakdown-label">${t.tax || 'BTW'}${data.taxesIncluded ? ' (inbegrepen)' : ''}</span>
                                <span class="breakdown-value">${currencySymbol}${parseFloat(data.totalTax || '0.00').toFixed(2)}</span>
                            </div>
                            `}
                            <div class="breakdown-row grand-total-row">
                                <span class="breakdown-label">${t.grandTotal || 'Totaalbedrag'}</span>
                                <span class="breakdown-value order-total-value">${currencySymbol}${parseFloat(data.totalPrice).toFixed(2)}</span>
                            </div>
                        </div>
                    </div>

                    ${isInvoiceAvailable ? `
                    <div class="invoice-download-section invoice-download-section--v2">
                        <button type="button" onclick="downloadInvoice('${data.orderNumber}', '${data.orderDate}', '${locale}')" class="invoice-download-btn invoice-download-btn--v2">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                <polyline points="7 10 12 15 17 10"></polyline>
                                <line x1="12" y1="15" x2="12" y2="3"></line>
                            </svg>
                            <span>${t.downloadInvoice}</span>
                        </button>
                    </div>
                    ` : ''}

                    <p class="order-thankyou">Bedankt voor je bestelling bij Smartwatchbanden.nl, je steun betekent veel voor ons!</p>
                </div>
            </div>
        `;

        resultsDiv.style.display = 'block';
        resultsDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        /* Live PostNL status inside the card we just rendered.
           NL + PostNL only, and it reuses the hasValidTracking verdict
           above so the sentinel list lives in exactly one place. The
           order card is already on screen, so a throw in here may never
           take it down: everything is wrapped. */
        try {
            if (window.SwbPnlTracking && typeof window.SwbPnlTracking.attach === 'function') {
                window.SwbPnlTracking.attach(resultsDiv.querySelector('.order-card'), data, {
                    carrier: displayCarrier,
                    hasTracking: hasValidTracking(data.trackingNumber)
                });
            }
        } catch (liveTrackingError) {
            console.log('Live tracking skipped:', liveTrackingError);
        }

        // Reset button after successful lookup
        lookupBtn.disabled = false;
        lookupBtn.innerHTML = `
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
            </svg>
            ${t.findMyOrder}
        `;

    } catch (error) {
        console.error('Fetch error:', error);
        // Use English for connection errors since we don't have locale info
        const errorT = translations['en-GB'];
        resultsDiv.innerHTML = `
            <div class="order-error">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
                <p>${errorT.connectionError}</p>
            </div>
        `;
        resultsDiv.style.display = 'block';

        // Reset button
        lookupBtn.disabled = false;
        lookupBtn.innerHTML = `
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
            </svg>
            ${errorT.findMyOrder}
        `;
    }
};

})();
// ============================================================================
// FAQ NAVIGATION - Bulletproof deep links to FAQ items
// Supports: #section.faq-item-id (e.g., #orders.faq-orders-track)
// Also supports: #section#faq-item-id and #faq-item-id
// ============================================================================
(function() {
    'use strict';

    function parseHash(hash) {
        if (!hash) return null;
        var dotIdx = hash.indexOf('.');
        if (dotIdx > 0) {
            return { section: hash.substring(0, dotIdx), faqId: hash.substring(dotIdx + 1) };
        }
        var hashIdx = hash.indexOf('#');
        if (hashIdx > 0) {
            return { section: hash.substring(0, hashIdx), faqId: hash.substring(hashIdx + 1) };
        }
        if (hash.startsWith('faq-')) {
            return { section: null, faqId: hash };
        }
        return { section: hash, faqId: null };
    }

    function forceShowSection(sectionId) {
        document.querySelectorAll('.cs-nav-item, .cs-mobile-menu-item').forEach(function(item) {
            item.classList.remove('active');
            if (item.dataset.section === sectionId) {
                item.classList.add('active');
            }
        });
        document.querySelectorAll('.cs-section').forEach(function(section) {
            if (section.id === sectionId) {
                section.classList.remove('page-hidden');
                section.classList.add('page-active');
            } else {
                section.classList.remove('page-active');
                section.classList.add('page-hidden');
            }
        });
    }

    function activateSection(sectionId) {
        if (typeof window.showSection === 'function') {
            window.showSection(sectionId);
        } else {
            forceShowSection(sectionId);
        }
    }

    function scrollToAndOpenFAQ(faqId, retries) {
        retries = retries || 0;
        var faqItem = document.getElementById(faqId);
        if (!faqItem) {
            if (retries < 15) {
                setTimeout(function() { scrollToAndOpenFAQ(faqId, retries + 1); }, 200);
            }
            return;
        }
        document.querySelectorAll('.faq-item.active').forEach(function(item) {
            item.classList.remove('active');
            if (typeof window.animateFaqClose === 'function') window.animateFaqClose(item.querySelector('.faq-answer'));
        });
        faqItem.classList.add('active');
        if (typeof window.animateFaqOpen === 'function') window.animateFaqOpen(faqItem.querySelector('.faq-answer'));
        requestAnimationFrame(function() {
            setTimeout(function() {
                faqItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 50);
        });
    }

    function handleFAQNavigation(hash) {
        if (!hash) return false;
        var parsed = parseHash(hash);
        if (!parsed) return false;
        if (parsed.section && parsed.faqId) {
            activateSection(parsed.section);
            setTimeout(function() { scrollToAndOpenFAQ(parsed.faqId, 0); }, 300);
            return true;
        }
        if (!parsed.section && parsed.faqId) {
            var faqItem = document.getElementById(parsed.faqId);
            if (faqItem) {
                var parentSection = faqItem.closest('.cs-section');
                if (parentSection) {
                    activateSection(parentSection.id);
                    setTimeout(function() { scrollToAndOpenFAQ(parsed.faqId, 0); }, 300);
                    return true;
                }
            }
            return false;
        }
        return false;
    }

    function init() {
        var hash = window.location.hash.substring(1);
        if (!hash) return;
        if (hash.includes('.') || hash.indexOf('#') > 0 || hash.startsWith('faq-')) {
            handleFAQNavigation(hash);
        }
    }

    var _faqInitDone = false;
    window.addEventListener('hashchange', function() {
        if (!_faqInitDone) { _faqInitDone = true; return; }
        var hash = window.location.hash.substring(1);
        if (hash && (hash.includes('.') || hash.indexOf('#') > 0 || hash.startsWith('faq-'))) {
            handleFAQNavigation(hash);
        }
    });

    document.addEventListener('click', function(e) {
        var link = e.target.closest('a[href]');
        if (!link) return;
        var href = link.getAttribute('href');
        var hash = '';
        if (href.startsWith('#')) {
            hash = href.substring(1);
        } else if (href.includes('#')) {
            try {
                var linkUrl = new URL(href, window.location.origin);
                hash = linkUrl.hash ? linkUrl.hash.substring(1) : '';
            } catch (err) { return; }
        }
        if (hash && (hash.includes('.') || hash.indexOf('#') > 0 || hash.startsWith('faq-'))) {
            e.preventDefault();
            e.stopPropagation();
            window.history.pushState({}, '', '#' + hash);
            handleFAQNavigation(hash);
        }
    }, true);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

// ===== SKELETON LOADER =====
window.showOrderSkeleton = function() {
    var el = document.getElementById('orderResults');
    if (!el) return;
    el.style.display = 'block';
    el.innerHTML = '<div class="order-skeleton">' +
        '<div class="skeleton-header">' +
        '<div class="skeleton-block" style="width:40%;height:28px;border-radius:8px"></div>' +
        '<div class="skeleton-block" style="width:25%;height:32px;border-radius:999px"></div>' +
        '</div>' +
        '<div class="skeleton-details">' +
        '<div class="skeleton-block" style="width:100%;height:14px;border-radius:6px"></div>' +
        '<div class="skeleton-block" style="width:75%;height:14px;border-radius:6px"></div>' +
        '<div class="skeleton-block" style="width:55%;height:14px;border-radius:6px"></div>' +
        '</div>' +
        '<div class="skeleton-items">' +
        '<div class="skeleton-block" style="width:100%;height:52px;border-radius:12px"></div>' +
        '<div class="skeleton-block" style="width:100%;height:52px;border-radius:12px"></div>' +
        '</div></div>';
};

window.hideOrderSkeleton = function() {
    var el = document.getElementById('orderResults');
    if (!el) return;
    var sk = el.querySelector('.order-skeleton');
    if (sk) sk.remove();
};

// ===== ORDER LOOKUP HANDLER (replaces inline onsubmit logic) =====
window.handleOrderLookup = function() {
    var btn = document.getElementById('lookupBtn');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.innerHTML = '<svg class="cs-btn-spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">' +
        '<path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> Zoeken...';
    window.showOrderSkeleton();
    var promise = window.lookupOrder();
    if (!promise || typeof promise.then !== 'function') {
        window.hideOrderSkeleton();
        btn.disabled = false;
        return;
    }
    promise.then(function() {
        window.hideOrderSkeleton();
        var hasOrder = !!document.querySelector('.order-card');
        if (hasOrder) {
            btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg> Bestelling gevonden';
            btn.disabled = true;
        } else {
            btn.disabled = false;
            btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.35-4.35"></path></svg> Zoek mijn bestelling';
        }
    }).catch(function() {
        window.hideOrderSkeleton();
        btn.disabled = false;
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.35-4.35"></path></svg> Zoek mijn bestelling';
    });
};

// ===== ORDER STATUS TIMELINE =====
(function() {
    var STEP_ICONS = [
        '<path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>',
        '<path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>',
        '<rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>',
        '<polyline points="20 6 9 17 4 12"/>'
    ];

    function getStep(statusText, orderCard) {
        // Als we de aanname hebben gedaan dat het bezorgd is (omdat de datum ver is verstreken),
        // forceren we de tijdlijn naar stap 4 (Bezorgd), ongeacht wat de Shopify status zegt.
        var isAssumedDelivered = !!orderCard.querySelector('.delivery-prediction--success-assumed');
        if (isAssumedDelivered) return 4;

        var s = statusText.toLowerCase();
        if (s.includes('delivered') || s.includes('geleverd')) return 4;
        if (s.includes('shipped') || s.includes('verzonden') || s.includes('versandt') || s.includes('enviado') || s.includes('expédié')) return 3;
        if (s.includes('processing') || s.includes('behandeling') || s.includes('bearbeitung') || s.includes('procesando') || s.includes('cours')) return 2;
        return 1;
    }

    function inject(orderCard) {
        if (orderCard.querySelector('.cs-order-timeline')) return;
        
        var finStatus = orderCard.getAttribute('data-financial-status');
        var ordStatus = orderCard.getAttribute('data-order-status');
        if (finStatus === 'Refunded' || finStatus === 'partially_refunded' || ordStatus === 'Cancelled') {
            return; // Hide the timeline entirely for refunded/cancelled orders
        }

        var badge = orderCard.querySelector('.order-status-badge');
        var status = badge ? badge.textContent : '';
        // Using getStep without second param here but safely passing it in case it's there
        var currentStep = getStep(status, orderCard);
        var isDelayed = !!orderCard.querySelector('[style*="FEE2E2"], [style*="FFF8E1"], .delivery-prediction--delayed, .delivery-prediction--critical');

        // Detect language context
        var isNL = document.documentElement.lang === 'nl' || orderCard.innerHTML.includes('Verwachte levering') || orderCard.innerHTML.includes('Afgeleverd');
        var finalLabel = (currentStep >= 4) ? (isNL ? 'Afgeleverd' : 'Zugestellt') : (isNL ? 'Verw. Levering' : 'Erw. Lieferung');
        
        var finalSublabel = '';
        var placedSublabel = '';
        var shippedSublabel = '';

        var dateEl = orderCard.querySelector('.order-date');
        if (dateEl) {
            var dateParts = dateEl.textContent.split(':');
            if (dateParts.length > 1) {
                placedSublabel = dateParts.pop().trim();
            } else {
                placedSublabel = dateEl.textContent.trim();
            }
        }

        var allSpans = orderCard.querySelectorAll('span');
        for (var i = 0; i < allSpans.length; i++) {
            var text = allSpans[i].textContent || '';
            
            if (text.includes('Bestellung versandt:') || text.includes('Bestelling verzonden:')) {
                if (allSpans[i].nextElementSibling && allSpans[i].nextElementSibling.tagName === 'SPAN') {
                    shippedSublabel = allSpans[i].nextElementSibling.textContent.trim();
                }
            } else if (text.includes('Versandt:') || text.includes('Verzonden:')) {
                shippedSublabel = text.replace(/Versandt:|Verzonden:/i, '').trim();
            }

            if (currentStep < 4) {
                if (text.includes('Voraussichtliche Ankunft') ||
                    text.includes('Erwartete Lieferung') ||
                    text.includes('Neue Erwartung:') ||
                    text.includes('Erwartete Lieferung war:') ||
                    text.includes('Nieuwe Verwachting:') ||
                    text.includes('Verwachte levering')) {
                    var dateStr = '';
                    if (text.includes('Neue Erwartung:') || text.includes('Nieuwe Verwachting:')) {
                        dateStr = text.split(/Neue Erwartung:|Nieuwe Verwachting:/i)[1].trim();
                    } else if (allSpans[i].nextElementSibling && allSpans[i].nextElementSibling.tagName === 'SPAN') {
                        dateStr = allSpans[i].nextElementSibling.textContent;
                    }
                    if (dateStr) {
                        var shortDate = dateStr.replace(/\b(Zondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrijdag|Zaterdag|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag),?\s*/gi, '').trim();
                        shortDate = shortDate.replace(/\s+/g, ' ').replace(/\s*-\s*/g, ' - ');
                        if (shortDate) { finalSublabel = shortDate; break; }
                    }
                }
            }
        }

        if (!finalSublabel && currentStep < 4) {
            var predictionBox = orderCard.querySelector('.delivery-prediction--normal');
            var delayedBox = orderCard.querySelector('.delivery-prediction--delayed');
            if (predictionBox) {
                var highlightEl = predictionBox.querySelector('.delivery-prediction__value--highlight');
                if (highlightEl) {
                    var dateText = highlightEl.textContent.trim();
                    var shortDate2 = dateText.replace(/\b(Zondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrijdag|Zaterdag|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag),?\s*/gi, '').trim();
                    shortDate2 = shortDate2.replace(/\s+/g, ' ').replace(/\s*-\s*/g, ' - ');
                    if (shortDate2) { finalSublabel = shortDate2; }
                }
            } else if (delayedBox) {
                var accentTag = delayedBox.querySelector('.delivery-prediction__tag--accent');
                if (accentTag) {
                    var tagText = accentTag.textContent;
                    if (tagText.includes('Neue Erwartung:') || tagText.includes('Nieuwe Verwachting:')) {
                        var dateStr2 = tagText.split(/Neue Erwartung:|Nieuwe Verwachting:/i)[1].trim();
                        var shortDate3 = dateStr2.replace(/\b(Zondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrijdag|Zaterdag|Sonntag|Montag|Dienstag|Mittwoch|Donnerstag|Freitag|Samstag),?\s*/gi, '').trim();
                        shortDate3 = shortDate3.replace(/\s+/g, ' ').replace(/\s*-\s*/g, ' - ');
                        if (shortDate3) { finalSublabel = shortDate3; }
                    }
                }
            }
        }

        var STEP_LABELS = isNL ? 
            ['Bestelling geplaatst', 'Verwerking', 'Verzonden', finalLabel] : 
            ['Bestellung aufgegeben', 'Verarbeitung', 'Versandt', finalLabel];
        var sublabels = [placedSublabel, '', shippedSublabel, finalSublabel];

        var stepsHTML = STEP_LABELS.map(function(label, idx) {
            var num = idx + 1;
            var cls = num < currentStep ? 'done' : (num === currentStep ? (isDelayed ? 'delayed' : 'current') : 'future');
            var sublabelHTML = '';
            var slText = sublabels[idx];
            if (slText) {
                var prefix = (idx === 3 && currentStep < 4 && !slText.includes('-')) ? '~ ' : '';
                sublabelHTML = '<span class="cs-timeline-sublabel">' + prefix + slText + '</span>';
            } else {
                sublabelHTML = '<span class="cs-timeline-sublabel" style="visibility: hidden;">&nbsp;</span>';
            }
            return '<div class="cs-timeline-step ' + cls + '">' +
                '<div class="cs-timeline-dot"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">' + STEP_ICONS[idx] + '</svg></div>' +
                '<span class="cs-timeline-label">' + label + '</span>' +
                sublabelHTML +
                '</div>';
        }).join('');

        var html = '<style>.cs-order-timeline .cs-timeline-steps { align-items: stretch !important; } .cs-order-timeline .cs-timeline-step { display: flex !important; flex-direction: column !important; } .cs-order-timeline .cs-timeline-sublabel { margin-top: auto !important; }</style><div class="cs-order-timeline"><div class="cs-timeline-steps">' + stepsHTML + '</div></div>';
        var orderItems = orderCard.querySelector('.order-items');
        if (orderItems) {
            orderItems.insertAdjacentHTML('beforebegin', html);
        } else {
            orderCard.insertAdjacentHTML('afterbegin', html);
        }

        var compactPred = orderCard.querySelector('.delivery-prediction--normal');
        if (finalSublabel && compactPred) {
            compactPred.classList.add('delivery-prediction--compact');
        }
    }

    // Watch for order card insertion
    var resultsDiv = document.getElementById('orderResults');
    if (resultsDiv) {
        var obs = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                m.addedNodes.forEach(function(node) {
                    if (node.nodeType !== 1) return;
                    var card = node.classList && node.classList.contains('order-card') ? node : node.querySelector && node.querySelector('.order-card');
                    if (card) inject(card);
                });
            });
        });
        obs.observe(resultsDiv, { childList: true, subtree: true });
    }
})();

// ===== LIVE SUPPORT HOURS =====
(function() {
    function nextOpenMsg(day, t) {
        if (day === 0 || day === 6 || (day === 5 && t >= 16)) return 'Maandag open om 8:00';
        if (t >= 16) return 'Morgen open om 8:00';
        if (t < 8)   return 'Vandaag open om 8:00';
        return 'Momenteel gesloten';
    }

    function update() {
        var badge = document.getElementById('csSupportBadge');
        if (!badge) return;
        var now = new Date();
        var day = now.getDay();
        var t = now.getHours() + now.getMinutes() / 60;
        var isOpen = day >= 1 && day <= 5 && t >= 8 && t < 16;
        badge.className = 'cs-support-badge cs-support-badge--' + (isOpen ? 'open' : 'closed');
        badge.innerHTML = '<span class="cs-support-badge-dot"></span> ' + (isOpen ? 'We zijn open' : nextOpenMsg(day, t));
    }

    update();
    setInterval(update, 60000);
})();

// ===== FLOATING QUICK-ACTION BAR =====
(function() {
    if (window.innerWidth > 767) return;
    var bar = document.getElementById('csQuickActions');
    if (!bar) return;
    if (sessionStorage.getItem('csQADismissed')) return;

    var shown = false;
    var lookupVisible = false;
    var lookupForm = document.getElementById('orderLookupForm');

    if (lookupForm && window.IntersectionObserver) {
        var io = new IntersectionObserver(function(entries) {
            lookupVisible = entries[0].isIntersecting;
            if (shown) bar.style.display = lookupVisible ? 'none' : '';
        }, { threshold: 0.5 });
        io.observe(lookupForm);
    }

    window.addEventListener('scroll', function() {
        if (!shown && window.scrollY > 300) {
            shown = true;
            if (!lookupVisible) bar.style.display = '';
        }
    }, { passive: true });

    var qaTrack = document.getElementById('qaTrackOrder');
    if (qaTrack) {
        qaTrack.addEventListener('click', function() {
            showSection('orders');
            setTimeout(function() {
                var input = document.getElementById('orderNumber');
                if (input) {
                    input.focus();
                    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 200);
        });
    }

    var qaChat = document.getElementById('qaChat');
    if (qaChat) {
        qaChat.addEventListener('click', function() {
            var dixaBtn = document.getElementById('csDixaButton');
            if (dixaBtn) dixaBtn.click();
        });
    }

    var closeBtn = document.getElementById('csQuickActionsClose');
    if (closeBtn) {
        closeBtn.addEventListener('click', function() {
            bar.style.display = 'none';
            sessionStorage.setItem('csQADismissed', '1');
        });
    }
})();
})();




/* ============================================================
   SERVICE HEALTH PROBE (n8n / order lookup maintenance notice)
   Smartwatchbanden / BWJ customer service

   The maintenance notice above the order-lookup widget is
   server-rendered ON. This routine removes it automatically as
   soon as the automation server answers correctly again, with
   no redeploy needed.

   Health proof: POST {"barcode":"PING","postcode":"0000AA"} to the
   status webhook. A healthy server rejects that barcode through its
   own validation path and answers HTTP 200 with
   {"ok":false,"error":"invalid", ...}. ONLY that exact shape counts
   as healthy. A 5xx, a Cloudflare 522, an HTML body, a CORS or
   network rejection and a timeout all count as still unhealthy, so
   the notice simply stays as rendered.

   The verdict is cached in sessionStorage for 3 minutes so a visitor
   browsing several service pages probes at most once per TTL.
   Everything here is non-blocking and failure silent.
   ============================================================ */
(function () {
    'use strict';

    var PROBE_URL  = 'https://actium.automagically.nl/webhook/ping';
    var CACHE_KEY  = 'swb_n8n_health_v1';
    var TTL_MS     = 3 * 60 * 1000;
    var TIMEOUT_MS = 5000;

    function notices() {
        try {
            return document.querySelectorAll('[data-cs-maint]');
        } catch (e) {
            return [];
        }
    }

    function hideNotices() {
        var nodes = notices();
        for (var i = 0; i < nodes.length; i++) {
            try {
                nodes[i].setAttribute('hidden', 'hidden');
                nodes[i].style.display = 'none';
            } catch (e) { /* ignore */ }
        }
    }

    function showNotices() {
        var nodes = notices();
        for (var i = 0; i < nodes.length; i++) {
            try {
                nodes[i].removeAttribute('hidden');
                nodes[i].style.display = '';
            } catch (e) { /* ignore */ }
        }
    }

    /* Returns true (healthy), false (unhealthy) or null (no fresh verdict). */
    function readCache() {
        try {
            var raw = window.sessionStorage.getItem(CACHE_KEY);
            if (!raw) { return null; }
            var parsed = JSON.parse(raw);
            if (!parsed || typeof parsed.t !== 'number') { return null; }
            if (Date.now() - parsed.t > TTL_MS) { return null; }
            return parsed.healthy === true;
        } catch (e) {
            return null;
        }
    }

    function writeCache(healthy) {
        try {
            window.sessionStorage.setItem(CACHE_KEY, JSON.stringify({
                healthy: healthy === true,
                t: Date.now()
            }));
        } catch (e) { /* private mode throws, verdict just is not cached */ }
    }

    function probe() {
        var timer = null;
        var options = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: '{}',
            cache: 'no-store'
        };

        function clear() {
            if (timer) { window.clearTimeout(timer); timer = null; }
        }

        try {
            if (typeof window.AbortController === 'function') {
                var controller = new window.AbortController();
                options.signal = controller.signal;
                timer = window.setTimeout(function () {
                    try { controller.abort(); } catch (e) { /* ignore */ }
                }, TIMEOUT_MS);
            }
        } catch (e) { /* no AbortController, fetch still resolves or rejects */ }

        return window.fetch(PROBE_URL, options).then(function (res) {
            clear();
            if (!res) { return false; }
            /* A 4xx means n8n ITSELF answered, so the server is up and the
               order lookup is fine; only the probe path is wrong. Treating that
               as "down" would show every customer a false maintenance notice,
               which is worse than missing one. So we fail OPEN on 4xx and only
               count a real infrastructure failure (5xx, 52x, network, timeout)
               as unhealthy. */
            if (res.status >= 500) { return false; }
            if (res.ok !== true) { return true; }
            return res.text().then(function (raw) {
                var data = null;
                try { data = JSON.parse(raw); } catch (e) { return false; }
                if (!data || typeof data !== 'object') { return false; }
                return data.ok === true;
            }, function () {
                return false;
            });
        }, function () {
            clear();
            return false;
        });
    }

    function run() {
        /* Setting is off, or this page has no notice: make no request at all. */
        if (!notices().length) { return; }
        if (typeof window.fetch !== 'function') { return; }

        /* The notice is rendered hidden, so a healthy page never flashes it.
           It is revealed ONLY on positive evidence that n8n is unhealthy. A
           known-unhealthy verdict from this session reveals it with no request. */
        var cached = readCache();
        if (cached === true)  { return; }
        if (cached === false) { showNotices(); return; }

        try {
            probe().then(function (healthy) {
                writeCache(healthy);
                if (!healthy) { showNotices(); }
            })['catch'](function () { /* silent */ });
        } catch (e) { /* silent */ }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})();

/* ============================================================
   LIVE POSTNL STATUS INSIDE THE ORDER CARD (SWB / smartwatchbanden.nl)

   The customer never sees a second form: they look their order up with
   ordernummer + e-mail exactly as before, and this block takes the
   trackingNumber and the shipping zip straight off that response and
   asks the PostNL proxy for the live status.

   Scope rules that this block never breaks:
     - PostNL + Netherlands only. Every other market keeps the carrier
       link it has today and never sees this block.
     - The order card is already on screen when we run. A failure here
       may never blank it, so every path ends in either a rendered
       status or the small inline failsafe form.
     - No links to the carrier's own site. The customer stays here.
     - Namespaced: every class and id starts with swb-pnl / swbPnl, and
       nothing in here uses document.getElementById.
     - No em dashes and no en dashes in customer facing copy.

   Ported from the standalone tracking page that this replaces:
   status headline + pill, per phase reassurance copy, letterbox aware
   delivered copy, shipment type line, expected delivery banner,
   4 step stepper and the collapsible scan timeline. The timeline
   toggle is a real button driving a class, never a flex summary,
   because a flex summary does not toggle on iOS Safari.
   ============================================================ */
(function () {
    'use strict';

    var ENDPOINT = 'https://actium.automagically.nl/webhook/postnl-status';
    var FETCH_TIMEOUT_MS = 10000;
    var WATCHDOG_MS = 11500;
    var BARCODE_RE = /^[A-Z0-9]{8,30}$/;
    var POSTCODE_RE = /^[0-9]{4}[A-Z]{2}$/;

    var STEP_LABELS = ['Aangemeld', 'Gesorteerd', 'Onderweg', 'Bezorgd'];

    var PHASE_HELP = {
        1: 'PostNL heeft je pakket aangemeld. Zodra PostNL het pakket scant, zie je hier de eerste update.',
        2: 'PostNL heeft je pakket gesorteerd. Het gaat nu richting het bezorgdepot.',
        3: 'PostNL heeft je pakket vandaag in de bezorgronde zitten.',
        delivered: 'Bezorgd door PostNL. Niks gevonden? Kijk even bij je buren of op een veilige plek bij je voordeur. Lukt dat niet, dan helpen we je graag verder.',
        deliveredLetterbox: 'PostNL heeft je pakket in je brievenbus bezorgd. Niks gevonden? Kijk of iemand anders in huis de post al heeft gepakt. Lukt dat niet, dan helpen we je graag verder.'
    };

    /* Every route into the failsafe, with the line the customer reads. */
    var FALLBACK_COPY = {
        no_tracking: {
            lead: 'Nog geen live status beschikbaar',
            message: 'Er is nog geen Track en Trace-code aan deze bestelling gekoppeld. Heb je zelf al een code van PostNL ontvangen? Vul hem hieronder in, samen met je postcode.'
        },
        no_zip: {
            lead: 'We hebben je postcode nodig',
            message: 'Vul je postcode in, dan halen we de live status van PostNL erbij.'
        },
        not_found: {
            lead: 'Geen zending gevonden',
            message: 'We vonden geen zending bij deze combinatie van Track en Trace-code en postcode. Controleer je gegevens en probeer het opnieuw. Is je pakket net verzonden? Dan staat het soms nog niet in het systeem van PostNL.'
        },
        invalid: {
            lead: 'Controleer je gegevens',
            message: 'De ingevulde gegevens lijken niet te kloppen. Controleer je Track en Trace-code en je postcode.'
        },
        unavailable: {
            lead: 'Live status even niet beschikbaar',
            message: 'We konden de actuele status van PostNL nu niet ophalen. Je pakket is gewoon onderweg. Probeer het zo nog een keer, of vul je Track en Trace-code en postcode hieronder in.'
        }
    };

    var LABELS = {
        brandPrefix: 'Verzonden met ',
        destTo: 'Op weg naar ',
        destDone: 'Bezorgd in ',
        shipmentType: 'Type zending: ',
        typeLetterbox: 'Brievenbuspakje',
        typeParcel: 'Pakket',
        deliveredOn: 'Bezorgd door PostNL op ',
        deliveredAt: ' om ',
        etaPrefix: 'Verwachte bezorging: ',
        etaBetween: ' tussen ',
        etaAnd: ' en ',
        progress: 'Voortgang van je zending',
        timelineTitle: 'Reis van je pakket',
        timelineSource: 'Scans van PostNL',
        eventFallback: 'Statusupdate',
        eventsEmptyEarly: 'PostNL heeft je pakket aangemeld. De eerste scan verschijnt meestal dezelfde avond.',
        eventsEmpty: 'Er zijn nog geen scanmomenten beschikbaar.',
        barcodeLabel: 'Track en Trace',
        loading: 'We halen de live status van PostNL op...',
        fieldBarcode: 'Track en Trace-code',
        fieldPostcode: 'Postcode',
        submit: 'Bekijk live status',
        submitBusy: 'Bezig...',
        errBarcode: 'Vul een geldige Track en Trace-code in, 8 tot 30 letters en cijfers.',
        errPostcode: 'Vul een geldige Nederlandse postcode in, bijvoorbeeld 1234 AB.'
    };

    var ICONS = {
        registered: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.29 7 12 12 20.71 7"></polyline><line x1="12" y1="22" x2="12" y2="12"></line></svg>',
        transit: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="1" y="3" width="15" height="13" rx="1"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>',
        delivered: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>',
        clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M12 6v6l4 2"></path></svg>',
        check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>',
        chevron: '<svg class="swb-pnl-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>',
        alert: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>'
    };

    /* Official PostNL logo, pasted from the standalone tracking page that
       this block replaces. PostNL publishes webshop logos for the shops
       that ship with them, and their terms forbid altering the mark, so it
       is never recoloured, stretched, redrawn or given a fill override.
       The only edits against that source file are the gradient id, which
       is namespaced swbPnlGrad because a duplicate SVG gradient id on one
       page silently steals the fill, and the class name so it stays inside
       the swb-pnl namespace.
       Branding only: this is not a link and never points at the carrier. */
    var POSTNL_LOGO = '<svg class="swb-pnl-brand-logo" xmlns="http://www.w3.org/2000/svg" viewBox="2 1.99 56.64 56.02" role="img" aria-label="PostNL" width="24" height="24"><defs><radialGradient id="swbPnlGrad" cx="22.53" cy="23.41" r="38.18" gradientTransform="matrix(.92633 -.3767 .33527 .82444 -6.22 12.52)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f1a100"/><stop offset=".23" stop-color="#f09e00"/><stop offset=".41" stop-color="#ee9401"/><stop offset=".57" stop-color="#eb8303"/><stop offset=".73" stop-color="#e66c05"/><stop offset=".87" stop-color="#e04e09"/><stop offset=".93" stop-color="#dd3f0a"/></radialGradient></defs><path d="M14.36 2c6.81 0 17.74 4.32 25 8.33 8 4.41 19.27 13.42 19.28 19.63 0 6.61-11.54 15.36-19.28 19.63C32.35 53.47 21.64 58 14.61 58a9.49 9.49 0 0 1-4.52-.94C4.53 54 2 40.86 2 30a67.93 67.93 0 0 1 1.94-16.19c1.48-5.75 3.61-9.54 6.15-10.94A8.91 8.91 0 0 1 14.36 2z" fill="#bbbbbc"/><path d="M56.78 30c0-4.71-8.87-12.88-18.32-18.09-10.89-6-23.28-9.55-27.37-7.3C6.44 7.14 3.89 20 3.89 30s2.4 22.74 7.2 25.39c4.36 2.4 16.21-1.14 27.37-7.29 9.6-5.33 18.31-13.19 18.32-18.1z" fill="url(#swbPnlGrad)"/><path d="M25.14 31a3.79 3.79 0 0 1-4.08 4A3.79 3.79 0 0 1 17 31a3.76 3.76 0 0 1 4.08-4.08A3.76 3.76 0 0 1 25.14 31zm-2.32 0c0-1.49-.75-2.14-1.76-2.14s-1.77.65-1.77 2.14.76 2.14 1.77 2.14 1.76-.81 1.76-2.14zm12.94-6.05c0-.06 0-.08-.09-.08A6.73 6.73 0 0 0 34 26a1.76 1.76 0 0 0-.44 1.17v5c0 2.18 1.25 2.86 2.6 2.86a3.58 3.58 0 0 0 1.62-.28.26.26 0 0 0 .12-.22v-1.42a.08.08 0 0 0-.1-.11 5.36 5.36 0 0 1-.92.2c-.7 0-1.12-.33-1.12-1.43v-2.86a.07.07 0 0 1 .08-.07h1.88a.08.08 0 0 0 .08-.08v-1.49a.25.25 0 0 0-.25-.24h-1.71a.07.07 0 0 1-.08-.08zM8.47 27.28a.25.25 0 0 1 .25-.28h3c2.93 0 4.44 1.75 4.44 4s-1.69 3.85-4.48 3.85h-.87a.08.08 0 0 0-.08.08v3.68c0 .06 0 .08-.09.08a6.54 6.54 0 0 1-1.69-1.16 1.72 1.72 0 0 1-.45-1.17zm5.45 3.66c0-1-.62-1.87-2.27-1.87h-.87a.09.09 0 0 0-.08.08v3.63a.08.08 0 0 0 .08.07h.91c1.97 0 2.23-1.36 2.23-1.91zm17.51-.32a4.74 4.74 0 0 0-1.57-.55l-.54-.07c-.67-.15-1.19-.26-1.19-.69s.35-.62.91-.62a8 8 0 0 1 2.74.54.1.1 0 0 0 .13-.08v-1.6a.26.26 0 0 0-.19-.24 9 9 0 0 0-2.41-.43 4.18 4.18 0 0 0-2.51.68 2.21 2.21 0 0 0-.92 1.85c0 1.73 1.42 2.06 2.76 2.37l.25.06c.62.14 1.25.28 1.25.78A.5.5 0 0 1 30 33a1.24 1.24 0 0 1-.94.25 13.57 13.57 0 0 1-3-.56.1.1 0 0 0-.1.09v1.55a.26.26 0 0 0 .18.24 10.18 10.18 0 0 0 2.74.47c2.32 0 3.52-.91 3.52-2.57a2.07 2.07 0 0 0-.97-1.85z" fill="#001a73"/><path d="M44.42 34.87h-.05v-4.74c0-1-.35-1.48-1.18-1.48a2.13 2.13 0 0 0-1 .31l-.73.43a.15.15 0 0 0-.06.11v5.32h-2.1v-7.54a.22.22 0 0 1 .22-.22h1.92a.05.05 0 0 1 0 .05v.59a.06.06 0 0 0 .06.06l.06-.05a3.51 3.51 0 0 1 .84-.47 4.52 4.52 0 0 1 1.54-.32c1.71 0 2.61 1 2.61 2.84v5.07zm5.94 0v-9.3a1.72 1.72 0 0 0-.36-1.2 6.57 6.57 0 0 0-1.67-1.15c-.06 0-.07 0-.07.05v11.55h.05zM24.51 25c.19 0 .27-.1.27-.31v-.85a.36.36 0 0 0-.36-.35H17.7a.35.35 0 0 0-.35.35v.85c0 .21.08.31.27.31zm.09-2.37c.12 0 .19 0 .22-.13l.14-.38c.26-.74.71-2 .8-2.31.14-.55.17-1.1-.58-1.38l-.73-.25c-.3-.09-.59-.16-.84-.22h-.14a.46.46 0 0 0-.42.29 13.58 13.58 0 0 0-.66 1.83.18.18 0 0 0 0 .13h.86c.1 0 .15 0 .17-.1a7.23 7.23 0 0 1 .37-1 .14.14 0 0 1 .13-.08H24l.38.13a.3.3 0 0 1 .14.38s-.76 2.12-1 2.82a.19.19 0 0 0 0 .18.18.18 0 0 0 .15.06zm-3.07 0c.17 0 .18-.19.18-.19s.05-4 .06-4.51a.24.24 0 0 0-.07-.18.13.13 0 0 0-.12-.05h-1a.13.13 0 0 0-.11.05.24.24 0 0 0-.07.18c0 .53.06 4.47.06 4.51s0 .19.18.19zm-3.1 0c.07 0 .12 0 .14-.06a.21.21 0 0 0 0-.18c-.22-.7-1-2.8-1-2.82a.31.31 0 0 1 .15-.38l.38-.13h.07a.14.14 0 0 1 .14.08 7.25 7.25 0 0 1 .36 1c0 .07.08.1.18.1h.74a.12.12 0 0 0 .11 0 .14.14 0 0 0 0-.13 12.33 12.33 0 0 0-.66-1.83.43.43 0 0 0-.41-.29h-.15c-.25.06-.54.13-.84.22l-.73.25c-.76.28-.73.83-.58 1.38.09.33.53 1.57.8 2.31.06.16.1.29.14.38a.19.19 0 0 0 .21.13zm2.63-5.74a.2.2 0 0 0 .13-.05A5.32 5.32 0 0 0 22 16a.14.14 0 0 0 0-.2 5.17 5.17 0 0 0-.91-.9h-.16a4.85 4.85 0 0 0-.91.9.14.14 0 0 0 0 .2 5.32 5.32 0 0 0 .85.86.18.18 0 0 0 .13.05z" fill="#fff"/></svg>';

    /* Small provenance chip at the top of the block. Neutral white ground,
       hairline border, PostNL navy for the name. PostNL orange sits about
       7 degrees of hue from our own #FF4F01, so it never appears as a UI
       accent here: the logo is the only place that orange is allowed. */
    function brandHtml() {
        return '<div class="swb-pnl-brandbar"><span class="swb-pnl-brand">' + POSTNL_LOGO +
            '<span class="swb-pnl-brand-text">' + LABELS.brandPrefix + '<strong>PostNL</strong></span>' +
            '</span></div>';
    }

    var uid = 0;

    /* ---- helpers ------------------------------------------ */

    function esc(value) {
        return String(value === null || value === undefined ? '' : value).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    function safeText(value) {
        if (typeof value === 'string') return value.trim();
        if (typeof value === 'number' && isFinite(value)) return String(value);
        return '';
    }

    function normBarcode(value) {
        return String(value === null || value === undefined ? '' : value).replace(/\s+/g, '').toUpperCase();
    }

    function normPostcode(value) {
        return String(value === null || value === undefined ? '' : value).replace(/\s+/g, '').toUpperCase();
    }

    function displayPostcode(value) {
        var p = normPostcode(value);
        return POSTCODE_RE.test(p) ? p.slice(0, 4) + ' ' + p.slice(4) : p;
    }

    function parseDate(iso) {
        if (!iso) return null;
        var d = new Date(iso);
        return isNaN(d.getTime()) ? null : d;
    }

    function fmtParts(iso, options) {
        var d = parseDate(iso);
        if (!d) return '';
        try {
            return new Intl.DateTimeFormat('nl-NL', options).format(d);
        } catch (e) {
            return '';
        }
    }

    function fmtLongDate(iso) {
        return fmtParts(iso, { weekday: 'long', day: 'numeric', month: 'long' });
    }

    function fmtTime(iso) {
        return fmtParts(iso, { hour: '2-digit', minute: '2-digit' });
    }

    function fmtStamp(iso) {
        var datePart = fmtParts(iso, { weekday: 'short', day: 'numeric', month: 'short' });
        if (!datePart) return '';
        var timePart = fmtTime(iso);
        return timePart ? datePart + ', ' + timePart : datePart;
    }

    /* An ok:true body with nothing in it is a failure wearing a success
       hat (the action-less 200 an n8n flow returns when it dies before
       its Respond node). Treat it as unavailable rather than render a
       hollow card that claims "Aangemeld". */
    function hasSubstance(data) {
        if (!data || typeof data !== 'object') return false;
        if (Array.isArray(data.events) && data.events.length) return true;
        if (safeText(data.statusDescription)) return true;
        if (parseDate(data.deliveredAt)) return true;
        var eta = (data.eta && typeof data.eta === 'object') ? data.eta : {};
        if (parseDate(eta.from) || parseDate(eta.to) || parseDate(eta.date)) return true;
        var phase = parseInt(data.phase, 10);
        return !isNaN(phase) && phase >= 1 && phase <= 4;
    }

    /* ---- the NL + PostNL gate ------------------------------ */

    function isPostNl(carrier) {
        return String(carrier === null || carrier === undefined ? '' : carrier).trim().toLowerCase() === 'postnl';
    }

    function isNl(addr) {
        var code = String((addr && addr.countryCode) || '').toUpperCase().trim();
        if (code) return code === 'NL';
        var name = String((addr && addr.country) || '').toLowerCase().trim();
        return name.indexOf('netherlands') !== -1 || name.indexOf('nederland') !== -1;
    }

    /* ---- shipment type (letterbox vs doorstep) ------------- */

    // "Brievenbuspakje+ ptp, gesorteerd" becomes "Brievenbuspakje+"
    function cleanProductDescription(raw) {
        if (typeof raw !== 'string') return '';
        var text = raw.replace(/,\s*(gesorteerd|standaard)\s*$/i, '');
        text = text.replace(/\bptp\b/gi, '');
        text = text.replace(/\s{2,}/g, ' ');
        text = text.replace(/[\s,;.-]+$/, '');
        return text.trim();
    }

    function newestEventText(data) {
        var events = Array.isArray(data.events) ? data.events : [];
        var best = null;
        var bestTime = -Infinity;
        events.forEach(function (ev) {
            if (!ev) return;
            var parsed = ev.time ? new Date(ev.time).getTime() : NaN;
            var value = isNaN(parsed) ? -Infinity : parsed;
            if (best === null || value > bestTime) {
                best = ev;
                bestTime = value;
            }
        });
        return (best && typeof best.description === 'string') ? best.description : '';
    }

    // The productDescription or the newest scan saying "brievenbus" is
    // what decides between the letterbox wording and the neighbours one.
    function isLetterbox(data) {
        var productText = (data && typeof data.productDescription === 'string') ? data.productDescription : '';
        if (/brievenbus/i.test(productText)) return true;
        return /brievenbus/i.test(newestEventText(data || {}));
    }

    function shipmentTypeLabel(data) {
        var cleaned = cleanProductDescription(data && data.productDescription);
        if (!cleaned) return '';
        return /brievenbus/i.test(cleaned) ? LABELS.typeLetterbox : LABELS.typeParcel;
    }

    /* ---- watchdog ------------------------------------------
       The 10 second abort needs AbortController and a fetch that really
       settles. This is the unconditional backstop just past it, so the
       spinner can never be the last thing the customer sees. */

    function clearWatchdog(ctx) {
        if (ctx.watchdog !== null) {
            window.clearTimeout(ctx.watchdog);
            ctx.watchdog = null;
        }
    }

    function armWatchdog(ctx, barcode, postcode) {
        clearWatchdog(ctx);
        ctx.watchdog = window.setTimeout(function () {
            ctx.watchdog = null;
            if (ctx.state === 'loading') renderFallback(ctx, 'unavailable', barcode, postcode);
        }, WATCHDOG_MS);
    }

    /* ---- fetch --------------------------------------------- */

    function fetchStatus(barcode, postcode) {
        if (typeof window.fetch !== 'function') {
            return Promise.reject(new Error('no_fetch'));
        }
        var controller = (typeof window.AbortController === 'function') ? new window.AbortController() : null;
        var timer = null;
        if (controller) {
            timer = window.setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT_MS);
        }
        function clear() {
            if (timer !== null) {
                window.clearTimeout(timer);
                timer = null;
            }
        }
        return fetch(ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ barcode: barcode, postcode: postcode, country: 'NL' }),
            signal: controller ? controller.signal : undefined
        }).then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json();
        }).then(function (data) {
            clear();
            return data;
        }, function (err) {
            clear();
            throw err;
        });
    }

    /* ---- rendering ----------------------------------------- */

    function bannerHtml(data, delivered) {
        if (delivered) {
            var dDate = fmtLongDate(data.deliveredAt);
            if (!dDate) return '';
            var dTime = fmtTime(data.deliveredAt);
            return '<div class="swb-pnl-banner swb-pnl-banner--delivered">' + ICONS.delivered +
                '<span>' + LABELS.deliveredOn + '<strong>' + esc(dDate) + '</strong>' +
                (dTime ? LABELS.deliveredAt + '<strong>' + esc(dTime) + '</strong>' : '') +
                '</span></div>';
        }
        var eta = (data.eta && typeof data.eta === 'object') ? data.eta : {};
        if (eta.from && eta.to) {
            var eDate = fmtLongDate(eta.from);
            var fromTime = fmtTime(eta.from);
            var toTime = fmtTime(eta.to);
            if (eDate && fromTime && toTime) {
                return '<div class="swb-pnl-banner">' + ICONS.clock +
                    '<span>' + LABELS.etaPrefix + '<strong>' + esc(eDate) + '</strong>' + LABELS.etaBetween +
                    '<strong>' + esc(fromTime) + LABELS.etaAnd + esc(toTime) + '</strong></span></div>';
            }
        }
        var oDate = fmtLongDate(eta.date || eta.from || eta.to);
        if (oDate) {
            return '<div class="swb-pnl-banner">' + ICONS.clock +
                '<span>' + LABELS.etaPrefix + '<strong>' + esc(oDate) + '</strong></span></div>';
        }
        return '';
    }

    function stepperHtml(phase, delivered) {
        var items = '';
        for (var i = 1; i <= 4; i++) {
            var cls = 'swb-pnl-step';
            if (delivered || i < phase) cls += ' is-done';
            else if (i === phase) cls += ' is-current';
            var ariaCurrent = (i === phase && !delivered) ? ' aria-current="step"' : '';
            items += '<li class="' + cls + '"' + ariaCurrent + '>' +
                '<span class="swb-pnl-step-dot">' + ICONS.check + '</span>' +
                '<span class="swb-pnl-step-label">' + STEP_LABELS[i - 1] + '</span></li>';
        }
        var listCls = delivered ? 'swb-pnl-stepper swb-pnl-stepper--delivered' : 'swb-pnl-stepper';
        return '<ol class="' + listCls + '" aria-label="' + LABELS.progress + '">' + items + '</ol>';
    }

    function timelineHtml(ctx, data, phase, delivered) {
        var events = Array.isArray(data.events) ? data.events.slice() : [];
        events.sort(function (a, b) {
            var ta = a && a.time ? new Date(a.time).getTime() : 0;
            var tb = b && b.time ? new Date(b.time).getTime() : 0;
            return (isNaN(tb) ? 0 : tb) - (isNaN(ta) ? 0 : ta);
        });

        var inner;
        if (events.length) {
            inner = '<ol class="swb-pnl-events">' + events.map(function (ev) {
                ev = ev || {};
                var stamp = fmtStamp(ev.time);
                var loc = safeText(ev.location);
                return '<li class="swb-pnl-event"><span class="swb-pnl-event-dot" aria-hidden="true"></span>' +
                    '<div class="swb-pnl-event-body">' +
                    (stamp ? '<span class="swb-pnl-event-time">' + esc(stamp) + '</span>' : '') +
                    '<span class="swb-pnl-event-desc">' + esc(safeText(ev.description) || LABELS.eventFallback) + '</span>' +
                    (loc ? '<span class="swb-pnl-event-loc">' + esc(loc) + '</span>' : '') +
                    '</div></li>';
            }).join('') + '</ol>';
        } else if (phase === 1 && !delivered) {
            inner = '<p class="swb-pnl-events-empty">' + LABELS.eventsEmptyEarly + '</p>';
        } else {
            inner = '<p class="swb-pnl-events-empty">' + LABELS.eventsEmpty + '</p>';
        }

        var bodyId = ctx.id + '-tl';
        return '<div class="swb-pnl-timeline" data-swb-pnl-timeline>' +
            '<button type="button" class="swb-pnl-timeline-toggle" data-swb-pnl-toggle aria-expanded="false" aria-controls="' + bodyId + '">' +
            '<span class="swb-pnl-timeline-heading">' + LABELS.timelineTitle +
            '<span class="swb-pnl-timeline-source">' + LABELS.timelineSource + '</span></span>' + ICONS.chevron + '</button>' +
            '<div class="swb-pnl-timeline-body" id="' + bodyId + '"><div class="swb-pnl-timeline-inner">' + inner + '</div></div></div>';
    }

    /* The complementary product row is a separate element parked right
       under this block. Any re-render (a retry from the failsafe form)
       goes through renderLoading first, so this is the single place that
       has to take the stale row away. */
    function clearRecos(ctx) {
        if (ctx.recos && ctx.recos.parentNode) ctx.recos.parentNode.removeChild(ctx.recos);
        ctx.recos = null;
    }

    function renderLoading(ctx) {
        clearRecos(ctx);
        ctx.state = 'loading';
        ctx.block.className = 'swb-pnl swb-pnl--loading';
        ctx.block.innerHTML =
            brandHtml() +
            '<div class="swb-pnl-skel" role="status" aria-live="polite">' +
            '<span class="swb-pnl-skel-circle"></span>' +
            '<span class="swb-pnl-skel-lines">' +
            '<span class="swb-pnl-skel-bar swb-pnl-skel-bar--pill"></span>' +
            '<span class="swb-pnl-skel-bar swb-pnl-skel-bar--title"></span>' +
            '<span class="swb-pnl-skel-bar swb-pnl-skel-bar--sub"></span>' +
            '</span></div>' +
            '<p class="swb-pnl-skel-note">' + LABELS.loading + '</p>';
    }

    function renderResult(ctx, data, barcode) {
        clearWatchdog(ctx);

        var phase = parseInt(data.phase, 10);
        if (isNaN(phase)) phase = 1;
        phase = Math.min(4, Math.max(1, phase));
        var delivered = data.isDelivered === true || phase === 4;
        if (delivered) phase = 4;

        var pillLabel = delivered ? STEP_LABELS[3] : STEP_LABELS[phase - 1];
        var statusIcon = delivered ? ICONS.delivered : (phase >= 3 ? ICONS.transit : ICONS.registered);
        var statusTitle = safeText(data.statusDescription) || pillLabel;
        var letterbox = isLetterbox(data);
        var helpCopy = delivered
            ? (letterbox ? PHASE_HELP.deliveredLetterbox : PHASE_HELP.delivered)
            : PHASE_HELP[phase];
        var typeLabel = shipmentTypeLabel(data);

        var dest = (data.destination && typeof data.destination === 'object') ? data.destination : {};
        var destCity = safeText(dest.city);
        var destZip = safeText(dest.zip);
        var destLine = '';
        if (destCity || destZip) {
            var zipCity = [displayPostcode(destZip), destCity].filter(Boolean).join(' ');
            destLine = (delivered ? LABELS.destDone : LABELS.destTo) + zipCity;
        }

        var banner = bannerHtml(data, delivered);
        var code = normBarcode(safeText(data.barcode)) || normBarcode(barcode);

        ctx.state = 'result';
        ctx.block.className = 'swb-pnl swb-pnl--result' + (delivered ? ' swb-pnl--delivered' : '');
        ctx.block.innerHTML =
            brandHtml() +
            '<div class="swb-pnl-hero">' +
            '<span class="swb-pnl-hero-icon">' + statusIcon + '</span>' +
            '<span class="swb-pnl-hero-text">' +
            '<span class="swb-pnl-pill">' + esc(pillLabel) + '</span>' +
            '<span class="swb-pnl-title">' + esc(statusTitle) + '</span>' +
            (destLine ? '<span class="swb-pnl-dest">' + esc(destLine) + '</span>' : '') +
            (typeLabel ? '<span class="swb-pnl-type">' + LABELS.shipmentType + '<strong>' + esc(typeLabel) + '</strong></span>' : '') +
            '</span></div>' +
            (helpCopy ? '<p class="swb-pnl-help">' + esc(helpCopy) + '</p>' : '') +
            banner +
            stepperHtml(phase, delivered) +
            timelineHtml(ctx, data, phase, delivered) +
            (code ? '<p class="swb-pnl-code"><span>' + LABELS.barcodeLabel + '</span><code>' + esc(code) + '</code></p>' : '');

        wireTimeline(ctx);

        /* Complementary products, from the order the proxy recognised.
           Lazy, non blocking and completely silent on failure: it is
           attached after the status is already painted, it renders
           nothing at all when it cannot find a decent row, and a throw
           in here may never take the status or the card down. */
        try {
            if (window.SwbPnlRecos && typeof window.SwbPnlRecos.attach === 'function') {
                ctx.recos = window.SwbPnlRecos.attach(ctx.block, data.order);
            }
        } catch (recosError) {
            ctx.recos = null;
        }

        /* The live carrier status now owns the shipment story in this
           card, so the card's own estimate engine steps aside. */
        ctx.card.classList.add('swb-pnl-live');
        if (delivered || banner) ctx.card.classList.add('swb-pnl-supersedes');
        else ctx.card.classList.remove('swb-pnl-supersedes');
    }

    function renderFallback(ctx, kind, barcode, postcode) {
        clearWatchdog(ctx);
        var key = Object.prototype.hasOwnProperty.call(FALLBACK_COPY, String(kind)) ? String(kind) : 'unavailable';
        var copy = FALLBACK_COPY[key];

        // A failed live lookup is not authoritative, so the card's own
        // estimate engine comes back.
        ctx.card.classList.remove('swb-pnl-live');
        ctx.card.classList.remove('swb-pnl-supersedes');

        /* The caller is authoritative about what goes in the fields. An
           explicit empty string means "do not prefill this one", which is
           what the no_tracking route wants: the order's own tracking value
           is a placeholder like "Not yet shipped" there, and normalising
           that would drop NOTYETSHIPPED into the customer's field. */
        var prefillCode = normBarcode(typeof barcode === 'string' ? barcode : ctx.barcode);
        var prefillZip = displayPostcode(typeof postcode === 'string' ? postcode : ctx.zip);
        var codeId = ctx.id + '-code';
        var zipId = ctx.id + '-zip';

        ctx.state = 'fallback';
        ctx.block.className = 'swb-pnl swb-pnl--fallback';
        ctx.block.innerHTML =
            // No shipment exists yet on the no_tracking route, so the
            // "Verzonden met PostNL" chip would be a false claim there.
            (key === 'no_tracking' ? '' : brandHtml()) +
            '<div class="swb-pnl-fb">' +
            '<span class="swb-pnl-fb-icon">' + ICONS.alert + '</span>' +
            '<span class="swb-pnl-fb-body">' +
            '<span class="swb-pnl-fb-lead">' + esc(copy.lead) + '</span>' +
            '<span class="swb-pnl-fb-msg">' + esc(copy.message) + '</span>' +
            '</span></div>' +
            '<div class="swb-pnl-fields">' +
            '<div class="swb-pnl-field">' +
            '<label for="' + codeId + '">' + LABELS.fieldBarcode + '</label>' +
            '<input type="text" id="' + codeId + '" data-swb-pnl-code autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="3SHDUT123456789" value="' + esc(prefillCode) + '">' +
            '</div>' +
            '<div class="swb-pnl-field">' +
            '<label for="' + zipId + '">' + LABELS.fieldPostcode + '</label>' +
            '<input type="text" id="' + zipId + '" data-swb-pnl-zip autocomplete="postal-code" autocapitalize="characters" spellcheck="false" placeholder="1234 AB" value="' + esc(prefillZip) + '">' +
            '</div></div>' +
            '<p class="swb-pnl-fb-error" data-swb-pnl-error hidden></p>' +
            '<button type="button" class="swb-pnl-btn" data-swb-pnl-submit>' + LABELS.submit + '</button>';

        wireFallback(ctx);
    }

    /* ---- wiring -------------------------------------------- */

    function wireTimeline(ctx) {
        var timeline = ctx.block.querySelector('[data-swb-pnl-timeline]');
        var toggle = ctx.block.querySelector('[data-swb-pnl-toggle]');
        if (!timeline || !toggle) return;

        // Open on desktop, collapsed on mobile so the card stays compact.
        var desktop = false;
        try {
            desktop = window.matchMedia('(min-width: 768px)').matches;
        } catch (e) {
            desktop = false;
        }
        if (desktop) {
            timeline.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
        }
        // A real button driving a class: a display:flex summary element
        // does not toggle on iOS Safari.
        toggle.addEventListener('click', function () {
            var open = timeline.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
    }

    function wireFallback(ctx) {
        var codeInput = ctx.block.querySelector('[data-swb-pnl-code]');
        var zipInput = ctx.block.querySelector('[data-swb-pnl-zip]');
        var errorEl = ctx.block.querySelector('[data-swb-pnl-error]');
        var button = ctx.block.querySelector('[data-swb-pnl-submit]');
        if (!button) return;

        function fail(message) {
            if (!errorEl) return;
            errorEl.textContent = message;
            errorEl.removeAttribute('hidden');
        }

        function submit() {
            if (errorEl) {
                errorEl.textContent = '';
                errorEl.setAttribute('hidden', 'hidden');
            }
            var code = normBarcode(codeInput ? codeInput.value : '');
            var zip = normPostcode(zipInput ? zipInput.value : '');
            if (!BARCODE_RE.test(code)) {
                fail(LABELS.errBarcode);
                if (codeInput) codeInput.focus();
                return;
            }
            if (!POSTCODE_RE.test(zip)) {
                fail(LABELS.errPostcode);
                if (zipInput) zipInput.focus();
                return;
            }
            button.disabled = true;
            button.textContent = LABELS.submitBusy;
            run(ctx, code, zip);
        }

        button.addEventListener('click', submit);
        [codeInput, zipInput].forEach(function (input) {
            if (!input) return;
            input.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    submit();
                }
            });
        });
    }

    /* ---- the run ------------------------------------------- */

    function run(ctx, barcode, postcode) {
        renderLoading(ctx);
        armWatchdog(ctx, barcode, postcode);

        fetchStatus(barcode, postcode).then(function (data) {
            if (ctx.state !== 'loading') return;
            if (!data || typeof data !== 'object' || data.ok !== true) {
                var kind = (data && data.ok === false) ? String(data.error || 'unavailable') : 'unavailable';
                renderFallback(ctx, kind, barcode, postcode);
                return;
            }
            if (!hasSubstance(data)) {
                renderFallback(ctx, 'unavailable', barcode, postcode);
                return;
            }
            try {
                renderResult(ctx, data, barcode);
            } catch (e) {
                renderFallback(ctx, 'unavailable', barcode, postcode);
            }
        }).catch(function () {
            if (ctx.state !== 'loading') return;
            renderFallback(ctx, 'unavailable', barcode, postcode);
        });
    }

    /* ---- entry point --------------------------------------- */

    /* Called by lookupOrder once the order card is on screen.
       opts.carrier      the carrier the card already decided to show
       opts.hasTracking  the verdict of the card's own hasValidTracking */
    function attach(card, data, opts) {
        if (!card || !data || typeof data !== 'object') return;
        if (card.querySelector('[data-swb-pnl]')) return;
        opts = opts || {};

        // Merchant kill switch on the section (data-live-tracking on the
        // results host). Scoped to this card, so a second copy of the
        // widget on one page can never answer for the first.
        try {
            var host = card.closest ? card.closest('[data-live-tracking]') : null;
            if (host && host.getAttribute('data-live-tracking') === 'off') return;
        } catch (e) { /* no closest support: the feature simply stays on */ }

        var addr = (data.shippingAddress && typeof data.shippingAddress === 'object') ? data.shippingAddress : {};

        // Gate: PostNL plus a defensive Netherlands check. Every other
        // market keeps exactly the behaviour it has today.
        if (!isPostNl(opts.carrier || data.carrier)) return;
        if (!isNl(addr)) return;

        // A cancelled or refunded order has no live shipment to show.
        var fin = String(data.financialStatus || '');
        if (fin === 'Refunded' || fin === 'partially_refunded' || data.status === 'Cancelled') return;

        var block = document.createElement('div');
        block.className = 'swb-pnl';
        block.setAttribute('data-swb-pnl', '');

        // Under the existing order details, above the line items.
        var anchor = card.querySelector('.order-mobile-tracking') ||
                     card.querySelector('.order-details') ||
                     card.querySelector('.order-card-body-v2');
        if (!anchor) return;
        if (anchor.classList.contains('order-card-body-v2')) anchor.insertAdjacentElement('afterbegin', block);
        else anchor.insertAdjacentElement('afterend', block);

        uid += 1;
        var ctx = {
            id: 'swbPnl' + uid,
            block: block,
            card: card,
            recos: null,
            watchdog: null,
            state: 'idle',
            barcode: normBarcode(data.trackingNumber),
            zip: normPostcode(addr.zip)
        };

        var hasTracking = (opts.hasTracking === true) ||
            (opts.hasTracking !== false && BARCODE_RE.test(ctx.barcode));

        if (!hasTracking || !BARCODE_RE.test(ctx.barcode)) {
            // A sentinel like "Not yet shipped" normalises to a string that
            // looks like a barcode, so drop it here as well and nothing
            // downstream can resurrect it.
            ctx.barcode = '';
            renderFallback(ctx, 'no_tracking', '', ctx.zip);
            return;
        }
        if (!POSTCODE_RE.test(ctx.zip)) {
            renderFallback(ctx, 'no_zip', ctx.barcode, '');
            return;
        }
        run(ctx, ctx.barcode, ctx.zip);
    }

    window.SwbPnlTracking = { attach: attach };
})();

/* ============================================================
   COMPLEMENTARY PRODUCTS UNDER THE LIVE POSTNL BLOCK (SWB)

   The proxy that answers the live status also hands back the order
   it recognised:
       order: { name, items: [ { productId, title, handle, image,
                                 productType, tags } ] }
   That is the only source used here. The CS lookup's own lineItems
   carry no product id, so they can never drive a recommendation.

   The rule is a complementary FLIP, ported from the standalone
   tracking page this block replaced:
     bought a strap (tag STRAP)          -> show accessories
     bought an accessory (ACCESSORY,
     CASE, SCREEN, CHARGER, UPSELL)      -> show straps
   and always for the watch they actually own. product_type is empty
   on every BWJ product, so tags are the only classifier. Model tags
   are the ALL CAPS tokens that are not brand, material, category or
   pipeline noise, which drops ALLPRODUCTS, gh*, n8n_batch*,
   filtervariant-*, variant_* and smartcoll_* on the regex alone.

   Scope rules this block never breaks:
     - It runs only after the live status has rendered, lazily, and a
       failure here is completely silent. It may never touch the
       tracking block, the failsafe or the order card.
     - Fewer than 3 usable products means no row at all. Never a stub,
       never a hanging spinner, never an empty heading.
     - 4 cards maximum. The standalone page showed 8; this is an
       inline context and the card stays light.
     - Every link points at our own storefront.
     - No em dashes and no en dashes in customer facing copy.
     - Namespaced swb-pnl-rec* so it can never collide with the CS
       page's own components.

   Everything between the ENGINE START and ENGINE END markers is
   DOM free and is exercised directly against the live storefront by
   the validation harness.
   ============================================================ */
(function () {
    'use strict';

    /* Inline context, not the standalone page. */
    var RECS_LIMIT = 4;
    var RECS_MIN = 3;

    var COPY = {
        accessory: {
            title: 'Maak je bandje compleet',
            subFor: 'Deze accessoires passen op je ',
            subPlain: 'Deze accessoires passen op je smartwatch.'
        },
        strap: {
            title: 'Nog een bandje erbij?',
            subFor: 'Deze bandjes passen op je ',
            subPlain: 'Deze bandjes passen op je smartwatch.'
        }
    };

    function esc(value) {
        return String(value === null || value === undefined ? '' : value).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    /* ============================================================
       ENGINE START
       ============================================================ */

    function shopRoot() {
        var root = '/';
        try {
            if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
                root = String(window.Shopify.routes.root);
            }
        } catch (e) {
            root = '/';
        }
        if (!root) root = '/';
        if (root.charAt(root.length - 1) !== '/') root += '/';
        return root;
    }

    function shopCurrency() {
        try {
            if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
                return String(window.Shopify.currency.active).toUpperCase();
            }
        } catch (e) { /* fall through to the euro */ }
        return 'EUR';
    }

    /* Verified live on smartwatchbanden.nl: straps carry STRAP,
       accessories carry ACCESSORY plus one of CASE, SCREEN, CHARGER.
       product_type is an empty string on every endpoint, so tags are
       the only reliable classifier here. */
    var TAG_STRAP = 'STRAP';
    var TAG_ACCESSORY_SET = { ACCESSORY: 1, CASE: 1, SCREEN: 1, CHARGER: 1, UPSELL: 1 };

    var TAG_CATEGORY_SET = {
        STRAP: 1, ACCESSORY: 1, CASE: 1, SCREEN: 1, CHARGER: 1, UPSELL: 1,
        ALLPRODUCTS: 1, BUNDLE: 1, GIFT: 1, SALE: 1, NEW: 1, OUTLET: 1
    };
    var TAG_MATERIAL_SET = {
        SILICONE: 1, SILICONEN: 1, NYLON: 1, MILANESE: 1, LEATHER: 1, LEDER: 1,
        METAL: 1, METALEN: 1, STEEL: 1, STAAL: 1, RVS: 1, MESH: 1, TPU: 1,
        RUBBER: 1, CANVAS: 1, BRAIDED: 1, GEVLOCHTEN: 1, MAGNETIC: 1,
        TITANIUM: 1, KERAMIEK: 1, CERAMIC: 1, GLASS: 1, GLAS: 1
    };
    var TAG_BRAND_SET = {
        GARMIN: 1, SAMSUNG: 1, APPLE: 1, FITBIT: 1, HUAWEI: 1, POLAR: 1,
        AMAZFIT: 1, XIAOMI: 1, SUUNTO: 1, WITHINGS: 1, GOOGLE: 1, FOSSIL: 1,
        TOMTOM: 1, OPPO: 1, ONEPLUS: 1, HONOR: 1, TICWATCH: 1, MOBVOI: 1,
        COROS: 1, NOTHING: 1, REDMI: 1, UNIVERSEEL: 1, UNIVERSAL: 1
    };

    var BRAND_WORDS = [
        'garmin', 'samsung', 'apple', 'fitbit', 'huawei', 'polar', 'amazfit',
        'xiaomi', 'suunto', 'withings', 'google', 'fossil', 'tomtom', 'oppo',
        'oneplus', 'honor', 'ticwatch', 'mobvoi', 'coros', 'nothing', 'redmi'
    ];

    /* Regex literals on purpose: in a JS string a backslash b is a
       BACKSPACE, so a pattern assembled from strings matches nothing. */
    var ACCESSORY_TITLE_RE = /(screenprotector|screen protector|schermbeschermer|protector|hard\s*case|\bcase\b|hoesje|cover|bumper|beschermhoes|etui|oplader|oplaadkabel|charger|charging|dock|kabel|\bcable\b|one-click|\btool\b)/i;
    var STRAP_TITLE_RE = /(bandje|bandjes|\bband\b|\bbanden\b|strap|straps|loop|armband|horlogeband)/i;

    var COLOUR_WORDS_RE = new RegExp('\\b(' + [
        'zwart', 'wit', 'grijs', 'donkergrijs', 'lichtgrijs', 'antraciet',
        'blauw', 'donkerblauw', 'lichtblauw', 'navy', 'kobalt', 'aqua',
        'groen', 'donkergroen', 'lichtgroen', 'olijf', 'khaki', 'mint',
        'rood', 'bordeaux', 'roze', 'paars', 'lavendel', 'violet', 'lila',
        'beige', 'bruin', 'taupe', 'creme', 'ivoor', 'geel', 'oranje',
        'goud', 'zilver', 'rosegoud', 'rose', 'brons', 'turquoise',
        'transparant', 'multicolour', 'multicolor', 'regenboog', 'rainbow',
        'sterrenlicht', 'starlight', 'dragonfruit', 'camo', 'marine', 'mix',
        'black', 'white', 'grey', 'gray', 'blue', 'green', 'red', 'pink',
        'purple', 'silver', 'gold', 'dark', 'light', 'clear'
    ].join('|') + ')\\b', 'g');

    function upperTagMap(tags) {
        var map = {};
        if (!Array.isArray(tags)) return map;
        tags.forEach(function (t) {
            if (typeof t === 'string' && t) map[t.toUpperCase()] = 1;
        });
        return map;
    }

    function classifyFromTitle(title) {
        var t = String(title || '');
        if (ACCESSORY_TITLE_RE.test(t)) return 'accessory';
        if (STRAP_TITLE_RE.test(t)) return 'strap';
        return '';
    }

    function classifyProduct(tags, title) {
        var map = upperTagMap(tags);
        if (map[TAG_STRAP]) return 'strap';
        var key;
        for (key in TAG_ACCESSORY_SET) {
            if (map[key]) return 'accessory';
        }
        return classifyFromTitle(title);
    }

    /* Model tags are the ALL CAPS tokens that are not brand, material,
       category or pipeline noise: VIVOACTIVE6, VIVOSMART5, FENIX5X. */
    function isModelTag(tag) {
        if (typeof tag !== 'string') return false;
        if (!/^[A-Z][A-Z0-9]{2,}$/.test(tag)) return false;
        if (TAG_CATEGORY_SET[tag]) return false;
        if (TAG_MATERIAL_SET[tag]) return false;
        if (TAG_BRAND_SET[tag]) return false;
        return true;
    }

    function modelTagsOf(tags) {
        var out = [];
        if (!Array.isArray(tags)) return out;
        tags.forEach(function (t) {
            if (isModelTag(t) && out.indexOf(t) === -1) out.push(t);
        });
        return out;
    }

    function brandTagOf(tags) {
        var found = '';
        if (!Array.isArray(tags)) return found;
        tags.forEach(function (t) {
            if (found) return;
            if (typeof t === 'string' && TAG_BRAND_SET[t.toUpperCase()]) found = t.toUpperCase();
        });
        return found;
    }

    // VIVOACTIVE6 becomes "vivoactive 6", FENIX5X becomes "fenix 5x".
    function modelTagToWords(tag) {
        var m = /^([A-Z]+?)(\d[A-Z0-9]*)$/.exec(String(tag || ''));
        if (m) return (m[1] + ' ' + m[2]).toLowerCase();
        return String(tag || '').toLowerCase();
    }

    function brandFromTitle(title) {
        var t = String(title || '').toLowerCase();
        var found = '';
        BRAND_WORDS.forEach(function (b) {
            if (found) return;
            if (t.indexOf(b) !== -1) found = b;
        });
        return found;
    }

    // "Garmin Vivosmart 5 siliconen bandje (bordeaux)" becomes "vivosmart 5"
    function modelWordsFromTitle(title) {
        var t = String(title || '').toLowerCase();
        t = t.replace(/\([^)]*\)/g, ' ');
        t = t.replace(/[^a-z0-9]+/g, ' ').trim();
        var stop = {
            siliconen: 1, silicone: 1, nylon: 1, milanese: 1, leren: 1, leer: 1,
            leather: 1, metalen: 1, staal: 1, stalen: 1, mesh: 1, gevlochten: 1,
            braided: 1, bandje: 1, bandjes: 1, band: 1, banden: 1, strap: 1,
            loop: 1, armband: 1, hard: 1, case: 1, hoesje: 1, cover: 1,
            screenprotector: 1, protector: 1, schermbeschermer: 1, oplader: 1,
            oplaadkabel: 1, charger: 1, kabel: 1, cable: 1, met: 1, voor: 1,
            classic: 1, sport: 1, alpine: 1, glas: 1, glass: 1, tool: 1,
            click: 1, one: 1, universeel: 1, bandz: 1
        };
        var words = t.split(' ');
        var out = [];
        for (var i = 0; i < words.length; i++) {
            var w = words[i];
            if (!w) continue;
            if (BRAND_WORDS.indexOf(w) !== -1) continue;
            if (stop[w]) break;
            out.push(w);
            if (out.length >= 4) break;
        }
        return out.join(' ');
    }

    function toCents(value) {
        if (typeof value === 'number' && isFinite(value)) return Math.round(value);
        if (typeof value === 'string' && value) {
            var n = parseFloat(value.replace(',', '.'));
            if (isFinite(n)) return Math.round(n * 100);
        }
        return null;
    }

    function pickImage(product) {
        var fi = product.featured_image;
        if (typeof fi === 'string' && fi) return fi;
        if (fi && typeof fi === 'object' && typeof fi.url === 'string' && fi.url) return fi.url;
        if (typeof product.image === 'string' && product.image) return product.image;
        if (product.image && typeof product.image === 'object' && typeof product.image.url === 'string') return product.image.url;
        return '';
    }

    /* recommendations/products.json returns CENTS, search/suggest.json
       returns euro STRINGS. Normalise both into one shape in cents. */
    function normProduct(raw) {
        if (!raw || typeof raw !== 'object') return null;
        var id = parseInt(raw.id, 10);
        if (isNaN(id) || id <= 0) return null;
        if (raw.available === false) return null;
        var handle = typeof raw.handle === 'string' ? raw.handle : '';
        /* The url is rebuilt from the handle rather than taken from the
           payload, so the pr_rec_id and _psq tracking parameters that
           search and recommendations bolt on never travel with the link. */
        if (!handle) return null;
        var priceCents = toCents(raw.price !== undefined ? raw.price : raw.price_min);
        if (priceCents === null) return null;
        var compareCents = toCents(
            raw.compare_at_price !== undefined && raw.compare_at_price !== null
                ? raw.compare_at_price
                : raw.compare_at_price_max
        );
        if (compareCents !== null && compareCents <= priceCents) compareCents = null;
        return {
            id: id,
            title: String(raw.title || ''),
            handle: handle.toLowerCase(),
            url: shopRoot() + 'products/' + handle,
            image: pickImage(raw),
            priceCents: priceCents,
            compareCents: compareCents,
            tags: Array.isArray(raw.tags) ? raw.tags : [],
            matchesModel: false
        };
    }

    /* Normalised stem used to cap near identical products. Strips the
       parenthetical colour, a trailing colour segment after a dash and
       any standalone colour word, but keeps the model words intact. */
    function titleStem(title) {
        var t = String(title || '').toLowerCase();
        t = t.replace(/\([^)]*\)/g, ' ');
        /* Escaped rather than literal so this source file itself stays
           free of em and en dashes; product TITLES do contain them. */
        t = t.replace(/\s*[-\u2013\u2014][^-\u2013\u2014]*$/, function (seg) {
            COLOUR_WORDS_RE.lastIndex = 0;
            var isColour = COLOUR_WORDS_RE.test(seg);
            COLOUR_WORDS_RE.lastIndex = 0;
            return isColour ? ' ' : seg;
        });
        t = t.replace(/[^a-z0-9]+/g, ' ');
        t = t.replace(COLOUR_WORDS_RE, ' ');
        COLOUR_WORDS_RE.lastIndex = 0;
        t = t.replace(/\s+/g, ' ').trim();
        return t;
    }

    function fetchJson(url) {
        return fetch(url, {
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin'
        }).then(function (res) {
            return res.ok ? res.json() : null;
        }).catch(function () {
            return null;
        });
    }

    function relatedUrl(productId, limit) {
        return shopRoot() + 'recommendations/products.json?product_id=' +
            encodeURIComponent(productId) + '&intent=related&limit=' + limit;
    }

    function collectionUrl(handle, limit) {
        return shopRoot() + 'collections/' + encodeURIComponent(handle) +
            '/products.json?limit=' + limit;
    }

    function suggestUrl(query, limit) {
        return shopRoot() + 'search/suggest.json?q=' + encodeURIComponent(query) +
            '&resources[type]=product&resources[limit]=' + limit;
    }

    function fetchRelated(productId) {
        return fetchJson(relatedUrl(productId, 10)).then(function (json) {
            return (json && Array.isArray(json.products)) ? json.products : [];
        });
    }

    /* Kept from the standalone engine so the source order stays intact.
       On BWJ this answers 200 with an empty products array today, so it
       costs one tiny request and contributes nothing; it starts working
       by itself the day those collections are exposed. */
    function fetchCollection(handle) {
        return fetchJson(collectionUrl(handle, 50)).then(function (json) {
            return (json && Array.isArray(json.products)) ? json.products : [];
        });
    }

    function fetchSuggest(query) {
        return fetchJson(suggestUrl(query, 10)).then(function (json) {
            if (!json || !json.resources || !json.resources.results) return [];
            var products = json.resources.results.products;
            return Array.isArray(products) ? products : [];
        });
    }

    // Reads the purchased items and works out what to show instead.
    function readPurchase(order) {
        var out = {
            ids: {},
            handles: {},
            seedIds: [],
            bought: '',
            want: 'accessory',
            brand: '',
            modelWords: '',
            modelTags: [],
            hasModel: false
        };
        var items = (order && Array.isArray(order.items)) ? order.items : [];
        var sawStrap = false;
        var sawAccessory = false;

        items.forEach(function (item) {
            if (!item) return;
            var pid = parseInt(item.productId, 10);
            if (!isNaN(pid) && pid > 0) {
                out.ids[pid] = true;
                if (out.seedIds.indexOf(pid) === -1 && out.seedIds.length < 2) out.seedIds.push(pid);
            }
            if (typeof item.handle === 'string' && item.handle) {
                out.handles[item.handle.toLowerCase()] = true;
            }

            var tags = Array.isArray(item.tags) ? item.tags : null;
            var title = item.title || '';
            /* Graceful degradation: no tags on the payload means classify
               from the title with Dutch and English keywords. */
            var cat = tags ? classifyProduct(tags, title) : classifyFromTitle(title);
            if (cat === 'strap') sawStrap = true;
            else if (cat === 'accessory') sawAccessory = true;

            if (tags) {
                var brand = brandTagOf(tags);
                if (brand && !out.brand) out.brand = brand.toLowerCase();
                modelTagsOf(tags).forEach(function (m) {
                    if (out.modelTags.indexOf(m) === -1) out.modelTags.push(m);
                });
            }
            if (!out.brand) {
                var tb = brandFromTitle(title);
                if (tb) out.brand = tb;
            }
            if (!out.modelWords) {
                var mw = modelWordsFromTitle(title);
                if (mw) out.modelWords = mw;
            }
        });

        if (!out.modelWords && out.modelTags.length) {
            out.modelWords = modelTagToWords(out.modelTags[0]);
        }
        out.hasModel = !!(out.modelTags.length || out.modelWords);

        if (sawStrap && sawAccessory) out.bought = 'mixed';
        else if (sawStrap) out.bought = 'strap';
        else if (sawAccessory) out.bought = 'accessory';

        /* The flip: a strap buyer gets accessories, an accessory buyer
           gets straps, a mixed order prefers accessories. */
        out.want = (out.bought === 'accessory') ? 'strap' : 'accessory';
        return out;
    }

    function categoryWordsFor(want) {
        return want === 'strap'
            ? ['bandje']
            : ['screenprotector', 'hard case', 'oplader'];
    }

    function collectionHandleFor(want, brand) {
        if (!brand) return '';
        return want === 'strap' ? brand + '-bandjes' : brand + '-accessoires';
    }

    /* Does this product fit the watch that was actually bought? A model
       tag match is the strong signal; the model words appearing as whole
       tokens in the title is the fallback for products missing the tag. */
    function fitsModel(purchase, product) {
        var map = upperTagMap(product.tags);
        var hit = false;
        purchase.modelTags.forEach(function (m) {
            if (map[m]) hit = true;
        });
        if (hit) return true;
        if (!purchase.modelWords) return false;
        var tokens = {};
        String(product.title || '').toLowerCase()
            .replace(/[^a-z0-9]+/g, ' ')
            .split(' ')
            .forEach(function (w) { if (w) tokens[w] = 1; });
        var wanted = purchase.modelWords.split(' ');
        for (var i = 0; i < wanted.length; i++) {
            if (wanted[i] && !tokens[wanted[i]]) return false;
        }
        return true;
    }

    /* Collector with dedupe: excludes the purchased items, the wrong
       category, anything that does not fit the customer's watch, and
       caps near identical titles at 2 per stem so the row is never one
       product in four colours. */
    function makeCollector(purchase) {
        var seenIds = {};
        var stemCount = {};
        var items = [];

        function accept(raw) {
            var p = normProduct(raw);
            if (!p) return;
            if (seenIds[p.id]) return;
            if (purchase.ids[p.id]) return;
            if (p.handle && purchase.handles[p.handle]) return;
            if (classifyProduct(p.tags, p.title) !== purchase.want) return;

            var stem = titleStem(p.title);
            var count = stemCount[stem] || 0;
            if (count >= 2) return;

            var matchesModel = fitsModel(purchase, p);
            /* Fit is the whole purchase criterion on this store, so when
               we know the customer's watch we never show something that
               does not fit it. Better no row than a wrong fit upsell. */
            if (purchase.hasModel && !matchesModel) return;
            p.matchesModel = matchesModel;

            stemCount[stem] = count + 1;
            seenIds[p.id] = true;
            items.push(p);
        }

        return {
            add: function (list) { (list || []).forEach(accept); },
            count: function () { return items.length; },
            result: function () {
                var primary = items.filter(function (p) { return p.matchesModel; });
                var rest = items.filter(function (p) { return !p.matchesModel; });
                return primary.concat(rest).slice(0, RECS_LIMIT);
            }
        };
    }

    /* Sourcing priority, stopping as soon as the row is full:
         1. brand collection for the opposite category, model filtered,
            plus predictive search on brand + model words + category word
         2. intent=related on the purchased ids, filtered by category
         3. predictive search on brand + a category word (brand level) */
    function gatherComplementary(purchase) {
        var collector = makeCollector(purchase);
        var catWords = categoryWordsFor(purchase.want);

        function stageOne() {
            var jobs = [];
            var handle = collectionHandleFor(purchase.want, purchase.brand);
            if (handle) jobs.push(fetchCollection(handle));
            if (purchase.modelWords) {
                catWords.forEach(function (cat) {
                    var q = (purchase.brand ? purchase.brand + ' ' : '') + purchase.modelWords + ' ' + cat;
                    jobs.push(fetchSuggest(q));
                });
            }
            if (!jobs.length) return Promise.resolve();
            return Promise.all(jobs).then(function (lists) {
                lists.forEach(function (list) { collector.add(list); });
            });
        }

        function stageTwo() {
            if (collector.count() >= RECS_LIMIT) return Promise.resolve();
            if (!purchase.seedIds.length) return Promise.resolve();
            return Promise.all(purchase.seedIds.map(fetchRelated)).then(function (lists) {
                lists.forEach(function (list) { collector.add(list); });
            });
        }

        function stageThree() {
            if (collector.count() >= RECS_MIN) return Promise.resolve();
            if (!purchase.brand) return Promise.resolve();
            return Promise.all(catWords.map(function (cat) {
                return fetchSuggest(purchase.brand + ' ' + cat);
            })).then(function (lists) {
                lists.forEach(function (list) { collector.add(list); });
            });
        }

        return stageOne()
            .then(stageTwo)
            .then(stageThree)
            .then(function () {
                var products = collector.result();
                // Fewer than 3 keepers means no row at all.
                if (products.length < RECS_MIN) return [];
                return products;
            })
            .catch(function () {
                return [];
            });
    }

    function titleCase(words) {
        return String(words || '').split(' ').map(function (w) {
            return w ? w.charAt(0).toUpperCase() + w.slice(1) : w;
        }).join(' ');
    }

    /* Only ever built from a model TAG, which is clean by construction.
       The title derived model words are good enough to filter with but
       not good enough to print. */
    function deviceLabel(purchase) {
        if (!purchase.modelTags.length) return '';
        var model = titleCase(modelTagToWords(purchase.modelTags[0]));
        if (!model) return '';
        var brand = purchase.brand ? titleCase(purchase.brand) : '';
        var label = brand ? brand + ' ' + model : model;
        return label.length > 32 ? '' : label;
    }

    // Headings follow what is in the row, never the other way round.
    function recsCopy(purchase) {
        var base = COPY[purchase.want] || COPY.accessory;
        var device = deviceLabel(purchase);
        return {
            title: base.title,
            sub: device ? base.subFor + device + '.' : base.subPlain
        };
    }

    function money(cents) {
        var n = Number(cents);
        if (!isFinite(n)) return '';
        var value = n / 100;
        try {
            return new Intl.NumberFormat('nl-NL', {
                style: 'currency',
                currency: shopCurrency(),
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        } catch (e) {
            return '€ ' + value.toFixed(2).replace('.', ',');
        }
    }

    /* ============================================================
       ENGINE END
       ============================================================ */

    function imgSrc(src) {
        if (typeof src !== 'string' || !src) return '';
        var url = src;
        if (url.indexOf('//') === 0) url = 'https:' + url;
        if (url.indexOf('http') !== 0) return '';
        if (url.indexOf('width=') === -1) {
            url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=400';
        }
        return url;
    }

    function cardHtml(product) {
        var src = imgSrc(product.image);
        var media = src
            ? '<img class="swb-pnl-rec-img" src="' + esc(src) + '" alt="' + esc(product.title) + '" loading="eager" decoding="async" width="400" height="400">'
            : '<span class="swb-pnl-rec-img swb-pnl-rec-img--empty" aria-hidden="true"></span>';

        return '<li class="swb-pnl-rec-item"><a class="swb-pnl-rec-card" href="' + esc(product.url) + '">' +
            '<span class="swb-pnl-rec-media">' + media + '</span>' +
            '<span class="swb-pnl-rec-body">' +
            '<span class="swb-pnl-rec-title">' + esc(product.title) + '</span>' +
            '<span class="swb-pnl-rec-price">' + esc(money(product.priceCents)) +
            (product.compareCents ? '<s class="swb-pnl-rec-compare">' + esc(money(product.compareCents)) + '</s>' : '') +
            '</span></span></a></li>';
    }

    function rowHtml(purchase, products) {
        var cards = products.map(cardHtml).join('');
        if (!cards) return '';
        var copy = recsCopy(purchase);
        return '<div class="swb-pnl-recos-head">' +
            '<h3 class="swb-pnl-recos-title">' + esc(copy.title) + '</h3>' +
            '<p class="swb-pnl-recos-sub">' + esc(copy.sub) + '</p>' +
            '</div><ul class="swb-pnl-rec-grid">' + cards + '</ul>';
    }

    /* ---- entry point --------------------------------------- */

    /* Called by the live status block once it has painted a result.
       afterEl  the rendered tracking block, this row goes right under it
       order    the order the PostNL proxy recognised
       Returns the host element so the caller can drop it on a re-render,
       or null when there is nothing to do. */
    function attach(afterEl, order) {
        if (!afterEl || !afterEl.parentNode) return null;
        if (!order || typeof order !== 'object') return null;
        if (!Array.isArray(order.items) || !order.items.length) return null;
        if (typeof window.fetch !== 'function') return null;

        var host = document.createElement('div');
        host.className = 'swb-pnl-recos';
        host.setAttribute('data-swb-pnl-recos', '');
        host.setAttribute('hidden', 'hidden');
        afterEl.insertAdjacentElement('afterend', host);

        function drop() {
            if (host.parentNode) host.parentNode.removeChild(host);
        }

        function start() {
            var purchase;
            try {
                purchase = readPurchase(order);
            } catch (e) {
                drop();
                return;
            }
            if (!purchase.seedIds.length) {
                drop();
                return;
            }
            gatherComplementary(purchase).then(function (products) {
                try {
                    if (!products || products.length < RECS_MIN) {
                        drop();
                        return;
                    }
                    var html = rowHtml(purchase, products);
                    if (!html) {
                        drop();
                        return;
                    }
                    host.innerHTML = html;
                    host.removeAttribute('hidden');
                } catch (e) {
                    drop();
                }
            }).catch(drop);
        }

        /* Lazy and non blocking. The status is already painted and this
           may never hold it, or the order card, up. */
        try {
            if (typeof window.requestIdleCallback === 'function') {
                window.requestIdleCallback(start, { timeout: 1500 });
            } else {
                window.setTimeout(start, 120);
            }
        } catch (e) {
            window.setTimeout(start, 120);
        }
        return host;
    }

    window.SwbPnlRecos = { attach: attach };
})();
